const coursesData = [
  {
    name: "Full Stack Python Development",
    slug: "advanced-python",
    mode: "Online & Offline & Hybrid",
    duration:"4 Months",
    icon:'fa-brands fa-python',
    logo:'python.png',
    description:'Dive into the world of Python programming with our comprehensive course. Whether you’re a beginner or an experienced coder, our curriculum covers everything from the fundamentals to advanced topics, ensuring you have the skills to develop powerful applications and solutions.',
    modules: [

      {
        id: 1,
        title: "1: Introduction to Python",
        content: [
          {description: "What is Python and history of Python?"},
          {description: "Unique features of Python"},
          {description: "Python-2 and Python-3 differences"},
          {description: "Install Python and Environment Setup"},
          {description: "First Python Program"},
          {description: "Python Identifiers, Keywords and Indentation"},
          {description: "Comments and document interlude in Python"},
          {description: "Command line arguments"},
          {description: "Getting User Input"},
          {description: "Python Data Types"},
          {description: "What are variables?"},
          {description: "Python Core objects and Functions"},
          {description: "Numbers and Math"},
          {description: "Week 1 Assignments"}
        ]
      },
      {
        id: 2,
        title: "2: Control Statements",
        content: [
          {description: "If – else"},
          {description: "if- elseif -else"},
          {description: "while loop"},
          {description: "for loop"},
          {description: "break"},
          {description: "continue"},
          {description: "pass"},
          {description: "return"}
        ]
      },
      {
        id: 3,
        title: "3: Functions in Python",
        content: [
          {description: "Introduction to functions"},
          {description: "Types of functions"},
          {description: "Declaration of Function in Python"},
          {description: "Exercise on functions"}
        ]
      },
      {
        id: 4,
        title: "4: Lists and Tuples in Python",
        content: [
          {description: "Introduction to List"},
          {description: "Difference between Lists and Array"},
          {description: "Methods of Lists"},
          {description: "Exercise on List"}
        ]
      },
      {
        id: 5,
        title: "5: Tuples in Python",
        content: [
          {description: "Introduction to tuples"},
          {description: "Difference between List and Tuples"},
          {description: "Methods of tuples"},
          {description: "Exercise on tuples"}
        ]
      },
      {
        id: 6,
        title: "6: Strings in Python",
        content: [
          {description: "Introduction to the strings"},
          {description: "Properties of Python strings"},
          {description: "Types of strings"},
          {description: "Methods of strings"},
          {description: "Exercise on strings"}
        ]
      },
      {
        id: 7,
        title: "7: Sets in Python",
        content: [
          {description: "Introduction to the set"},
          {description: "Properties of Python sets"},
          {description: "Types of sets"},
          {description: "Methods of sets"},
          {description: "Exercise on sets"}
        ]
      },
      {
        id: 8,
        title: "8: Dictionaries in Python",
        content: [
          {description: "Introduction to the Dictionaries"},
          {description: "Difference between Hash table and Python Dictionaries"},
          {description: "Methods of Dictionaries"},
          {description: "Exercise on Dictionaries"}
        ]
      },
      {
        id: 9,
        title: "9: Introduction to Expression Oriented Programming (EOP)",
        content: [
          {description: "Types of function parameters"},
          {description: "Iterators and Generators"},
          {description: "Introduction to anonymous(Lambda) functions in Python"},
          {description: "Use of anonymous(Lambda) functions"},
          {description: "Introduction to List Comprehensions"},
          {description: "Introduction to Set Comprehensions"},
          {description: "Introduction to Dictionary Comprehensions"},
          {description: "Introduction to Generator Comprehensions"},
          {description: "Introduction and use of Python built-in functions"},
          {description: "Exercise on EOP"}
        ]
      },
      {
        id: 10,
        title: "10: Exception Handling in Python",
        content: [
          {description: "What is Exception"},
          {description: "Compile-time errors"},
          {description: "Runtime Errors"},
          {description: "Difference between Warnings and Exceptions"},
          {description: "Necessity of handling an exception"},
          {description: "try-except-finally"},
          {description: "try-except-else"},
          {description: "raising an exception"},
          {description: "Python standard exceptions"},
          {description: "User-Defined Exceptions"}
        ]
      },
      {
        id: 11,
        title: "11: Input and Output in Python",
        content: [
          {description: "Introduction to files"},
          {description: "Difference between files and databases"},
          {description: "Operations on files"},
          {description: "Modes of files"},
          {description: "Methods of files"},
          {description: "Exercise on file"}
        ]
      },
      {
        id: 12,
        title: "12: Python Object Serialization",
        content: [
          {description: "Introduction to serialization"},
          {description: "Introduction to Pickle library"},
          {description: "Difference between Pickle and JSON"},
          {description: "Methods of Pickle library"},
          {description: "Exercise on pickle"}
        ]
      },
      {
        id: 13,
        title: "13: DB-API using SQLite3 Databases in Python",
        content: [
          {description: "Python SQLite3 Database Access"},
          {description: "Create Database Connection"},
          {description: "CREATE, INSERT, READ, UPDATE and DELETE Operation"},
          {description: "DML and DDL Operation with Databases"},
          {description: "Types of database keys"},
          {description: "Performing Transactions"},
          {description: "Handling Database Errors"}
        ]
      },
      {
        id: 14,
        title: "14: Decorators in Python",
        content: [
          {description: "Everything in Python is an object"},
          {description: "Defining functions within functions (Nested Functions)"},
          {description: "Returning functions from within functions"},
          {description: "Giving a function as an argument to another function"},
          {description: "Writing your first decorator"},
          {description: "Decorators with Arguments"}
        ]
      },
      {
        id: 15,
        title: "15: Python Multithreaded Programming",
        content: [
          {description: "What is multithreading?"},
          {description: "What is multiprocessing?"},
          {description: "Difference between a Process and Thread"},
          {description: "Difference between Parallel and Serial processing"},
          {description: "Concurrent Programming and GIL"},
          {description: "Thread Synchronization"},
          {description: "Locks"},
          {description: "Deadlock of Threads"},
          {description: "Avoiding Deadlocks"},
          {description: "Semaphore"},
          {description: "Daemon Threads"},
          {description: "Exercise on Threading module"}
        ]
      },
      {
        id: 16,
        title: "16: Regular Expressions (re module) in Python",
        content: [
          {description: "What are regular expressions?"},
          {description: "Why, where, when to use regex"},
          {description: "Declaration of regex"},
          {description: "Wildcard characters in regex"},
          {description: "Methods of regex"},
          {description: "Extended Regular Expressions"}
        ]
      },
      {
        id: 17,
        title: "17: Introduction of Object-Oriented Programming",
        content: [
          {description: "The special methods of Python"},
          {description: "The self-variable"},
          {description: "Pillars of OOP (Inheritance, Polymorphism, Encapsulation, Data Abstraction)"},
          {description: "Difference between Methods and Functions"},
          {description: "Types of variables"},
          {description: "Types of Methods"},
          {description: "Instance Methods"},
          {description: "Class methods"},
          {description: "Static methods"},
          {description: "Destroying Objects"},
          {description: "Abstract Methods and Abstract class"},
          {description: "Exercise on OOP"}
        ]
      },
      {
        id: 18,
        title: "18: Web Scraping in Python",
        content: [
          {description: "Introduction to Data Crawling using Python"},
          {description: "Introduction to Beautifulsoup library"},
          {description: "Introduction to urllib, requests library"},
          {description: "Project 1: Live application on web scrapping"}
        ]
      },
      {
        id: 19,
        title: "19. Data Analysis with Python - Numpy",
        content: [
          { description: 'Introduction to numpy' },
          { description: 'Difference between Python Lists and Numpy' },
          { description: 'Creating arrays' },
          { description: 'Using arrays and Scalars' },
          { description: 'Indexing Arrays' },
          { description: 'Array Transposition' },
          { description: 'Universal Array Function' },
          { description: 'Array Processing' },
          { description: 'Array Input and Output' },
          { description: 'Exercise on Numpy' }
        ]
      },
      {
        id: 20,
        title: "19. Data Analysis with Python - Pandas",
        content: [
          { description: 'Introduction to pandas' },
          { description: 'Where it is used?' },
          { description: 'Index objects' },
          { description: 'Data Structure of Pandas - Series, DataFrame, Panel' },

          { description: 'Reindex' },
          { description: 'Drop Entry' },
          { description: 'Selecting Entries' },
          { description: 'Data Alignment' },
          { description: 'Rank and Sort' },
          { description: 'Loc and iloc indexing' }
        ]
      },
      {
        id: 21,
        title: "19. Data Analysis with Python - Matplotlib: Data Visualization",
        content: [
          { description: 'Introduction of Data Visualization' },
          { description: 'Introduction to Matplotlib' },
          { description: 'Types of plots in Matplotlib' },
          { description: '3D plotting with Matplotlib' },

          { description: 'Basic and Specialized Visualization Tools' },
          { description: 'Project 1: Data Analysis Project on sales data' },
          { description: 'Project 2: Data Analysis Project on Big data' },
        ]
      },
      {
        id: 22,
        title: "20: Graphical User Interface (Optional topic)",
        content: [
          {description: "GUI in Python"},
          {description: "The Root Window"},
          {description: "Fonts and Colors"},
          {description: "Working with containers"},
          {description: "Canvas"},
          {description: "Frame Advance Python Syllabus"},
          {description: "Widget"},
          {description: "Button Widget"},
          {description: "Arrange Widget in the Frame"},
          {description: "Label Widget"},
          {description: "Message Widget"},
          {description: "Text Widget"},
          {description: "Scrollbar Widget"},
          {description: "Check button Widget"},
          {description: "Radio button Widget"},
          {description: "Entry Widget"},
          {description: "Spinbox Widget"},
          {description: "Listbox Widget"},
          {description: "Menu Widget"},
          {description: "Creating Tables"}
        ]
      },
      {
        id: 23,
        title: "21: Django Web Framework in Python",
        content: [
          {description: "What is Django?"},
          {description: "Why do we need a framework?"},
          {description: "What happens when someone requests a website from your server?"},
          {description: "Why is Django a good for web framework choice?"},
          {description: "Django installation"},
          {description: "Introduction to MVC and MVT architecture in Web development"},
          {description: "Django folder structure and flow of control"},
          {description: "Creation of first Django project"},
          {description: "Django models"},
          {description: "Django admin"},
          {description: "Django urls"},
          {description: "Django views-time to create"},
          {description: "Django settings"},
          {description: "Django migrations"},
          {description: "Django ORM (Query sets) Advance Python Syllabus"},
          {description: "Introduction to HTML"},
          {description: "Dynamic data in template"},
          {description: "Django templates"},
          {description: "Deploying and handling static and media files"},
          {description: "CSS- make it pretty"},
          {description: "Template extending"},
          {description: "Extend your application"},
          {description: "Django Forms"},
          {description: "Introduction to REST Framework"},
          {description: "Use and advancing the project using REST API"},
          {description: "Django Testing"},
          {description: "Open source Django example projects"},
          {description: "Django interview Questions"}
        ]
      },
      {
        id: 24,
        title: "22: Github",
        content: [
          {description: "Creating Github account and profile"},
          {description: "Installing git in system"},
          {description: "Creating repository"},
          {description: "Different stages of github"},
          {description: "Different github commands"}
        ]
      }


    ]
  },
  {
    name: "Data Science With Python",
    slug: "data-science-with-python",
    mode: "Online & Offline & Hybrid",
    duration:"4 Months",
    description:'Unlock the potential of data with our Data Science course. Learn how to analyze large datasets, derive valuable insights, and make data-driven decisions. From statistical analysis to machine learning techniques, our course provides you with the tools and techniques needed to excel in the field of data science.',
    icon:'fa fa-server',
    logo:'1.png',
    modules: [
      {
        id: 1,
        title: "Chapter 1: Jupyter Notebook",
        content: [
          { description: 'Introduction' },
          { description: 'Basic Commands' },
          { description: 'Keyboard Shortcut and Magic Functions' }             
        ]
      },
      {
        id: 2,
        title: "Chapter 2: Data Analysis with Python - Numpy",
        content: [
          { description: 'Introduction to numpy' },
          { description: 'Difference between Python Lists and Numpy' },
          { description: 'Creating arrays' },
          { description: 'Using arrays and Scalars' },
          { description: 'Indexing Arrays' },
          { description: 'Array Transposition' },
          { description: 'Universal Array Function' },
          { description: 'Array Processing' },
          { description: 'Array Input and Output' },
          { description: 'Exercise on Numpy' }
        ]
      },
      {
        id: 3,
        title: "Chapter 2: Data Analysis with Python - Pandas",
        content: [
          { description: 'Introduction to pandas' },
          { description: 'Where it is used?' },
          { description: 'Index objects' },
          { description: 'Data Structure of Pandas - Series, DataFrame, Panel' },

          { description: 'Reindex' },
          { description: 'Drop Entry' },
          { description: 'Selecting Entries' },
          { description: 'Data Alignment' },
          { description: 'Rank and Sort' },
          { description: 'Loc and iloc indexing' }
        ]
      },
      {
        id: 4,
        title: "Chapter 2: Data Analysis with Python - Pandas",
        content: [
          { description: 'Introduction to pandas' },
          { description: 'Where it is used?' },
          { description: 'Index objects' },
          { description: 'Data Structure of Pandas - Series, DataFrame, Panel' },

          { description: 'Reindex' },
          { description: 'Drop Entry' },
          { description: 'Selecting Entries' },
          { description: 'Data Alignment' },
          { description: 'Rank and Sort' },
          { description: 'Loc and iloc indexing' },
          { description: 'Summary Statistics' },
          { description: 'Handling Missing Data' },
          { description: 'Index Hierarchy' },
          { description: 'Exercise on Pandas' }
        ]
      },
      {
        id: 5,
        title: "Chapter 2: Data Analysis with Python - Matplotlib: Data Visualization",
        content: [
          { description: 'Introduction to pandas' },
          { description: 'Where it is used?' },
          { description: 'Index objects' },
          { description: 'Data Structure of Pandas - Series, DataFrame, Panel' },

          { description: 'Reindex' },
          { description: 'Drop Entry' },
          { description: 'Selecting Entries' },
          { description: 'Data Alignment' },
          { description: 'Rank and Sort' },
          { description: 'Loc and iloc indexing' },
          { description: 'Summary Statistics' },
          { description: 'Handling Missing Data' },
          { description: 'Index Hierarchy' },
          { description: 'Exercise on Pandas' }
        ]
      },
      {
        id: 6,
        title: "Chapter 3: GIT",
        content: [
          {description:"Distribution Version Control System"},
          {description:"How internally, GIT Manages Version Control on Changesets."},
          {description:"Creating Repository"},
          {description:"Basic Commands like, git status, git add, git re-move, git branch, git checkout, git log, git cat-file, git pull, git push, git commit"},
          {description:"Managing Configuration – System Level, User Level, Repository level"}
        ]
      },
      {
        id: 7,
        title: "Chapter 4: Statistics and Probability",
        content: [
          {description: "Descriptive Statistics"},
          {description: "Inferential Statistics"},
          {description: "Linear Algebra and Calculus"}
        ]
      },
      {
        id: 8,
        title: "Chapter 5: Machine Learning Introduction",
        content: [
          {description: "What is Machine Learning?"},
          {description: "Missing Data Imputation"},
          {description: "Complete case analysis"},
          {description: "Mean / Median/Mode imputation"},
          {description: "Random Sample Imputation"},
          {description: "Replacement by Arbitrary Value"},
          {description: "Missing Value Indicator"},
          {description: "Multivariate imputation"},
          {description: "Handling Outliers Removal"},
          {description: "Removing Outliers"},
          {description: "Treating Outliers as NaN"},
          {description: "Capping, Windsorisation"},
          {description: "Binning"},
          {description: "Log Transform"},
          {description: "Categorical Encoding"},
          {description: "One Hot Encoding"},
          {description: "Count and Frequency Encoding"},
          {description: "Target Encoding/Mean Encoding"},
          {description: "Ordinal Encoding"},
          {description: "Weight of Evidence"},
          {description: "Rare label Encoding"},
          {description: "BaseN, feature hashing and others"},
          {description: "Grouping Operations"},
          {description: "Feature Split"},
          {description: "Feature Scaling"},
          {description: "Standardization"},
          {description: "MinMax Scaling"},
          {description: "Mean Scaling"},
          {description: "Max Absolute Scaling"},
          {description: "Unit norm-scaling"},
          {description: "Date and Time Engineering"},
          {description: "Extracting days, months, years, quarters, time elapsed"},
          {description: "Feature Creation"},
          {description: "Sum"},
          {description: "Subtraction"},
          {description: "Mean, min, max, product"}
        ]
      },
      {
        id: 9,
        title: "Chapter 6: Fundamental Techniques of Feature Engineering for Machine Learning",
        content: [
          {description: "Machine Learning Process Flow-Diagram"},
          {description: "Linear Regression"},
          {description: "Robust Regression (RANSAC Algorithm)"},
          {description: "Exploratory Data Analysis (EDA)"},
          {description: "Correlation Analysis and Feature Selection"},
          {description: "Performance Evaluation –"},
          {description: "Residual Analysis,"},
          {description: "Mean Square Error (MSE)"},
          {description: "Co-efficient of Determination R^2"},
          {description: "Mean Absolute Error (MAE)"},
          {description: "Root Mean Square Error (RMSE)"},
          {description: "Polynomial Regression"},
          {description: "Regularized Regression"},
          {description: "Ridge, Lasso"},
          {description: "Elastic Net Regression"},
          {description: "Bias-Variance Trade-Off"},
          {description: "Cross Validation"},
          {description: "Hold Out"},
          {description: "K-Fold Cross Validation"},
          {description: "Data Pre-Processing –"},
          {description: "Standardization"},
          {description: "Min-Max"},
          {description: "Normalization and Binarization"}
        ]
      },
      {
        id: 10,
        title: "Chapter 7: Regression",
        content: [
          {description: "Different Categories of Machine Leaning –"},
          {description: "Supervised"},
          {description: "Unsupervised"},
          {description: "Reinforcement Learning"},
          {description: "Scikit-Learn Overview"},
          {description: "Scikit-Learn cheat-sheet"}
        ]
      },
      {
        id: 11,
        title: "Chapter 8: Classification – Logistic Regression",
        content: [
          {description: "Sigmoid function"},
          {description: "Logistic Regression learning using Stochastic Gradient Descent (SGD)"},
          {description: "SGD Classifier"},
          {description: "Measuring accuracy using Cross-Validation, Stratified k-fold"},
          {description: "Confusion Matrix – True Positive (TP), False Positive (FP), False Negative (FN), True Negative (TN)"},
          {description: "Precision, Recall, F1 Score, Precision/Recall Trade- Off, Receiver Operating Characteristics (ROC) Curve."},
          {description: "Gradient Descent"}
        ]
      },
      {
        id: 12,
        title: "Chapter 9: Classification –Decision Trees",
        content: [
          {description: "CART (Classification and Regression Tree)"},
          {description: "Advantages and Disadvantages and its applications."},
          {description: "Decision Tree Learning algorithms – ID3, C4.5, C5.0 and CART."},
          {description: "Gini Impurity, Entropy and Information Gain"},
          {description: "Decision Tree Regression"},
          {description: "Visualizing a Decision Tree using graphviz module."},
          {description: "Regularization using tuning hyper-parameters using GridSearch CV"}
        ]
      },
      {
        id: 13,
        title: "Chapter 10: Classification – Ensemble Methods",
        content: [
          {description: "Bootstrap Aggregating or Bagging"},
          {description: "Random Forest algorithm"},
          {description: "Extremely Randomized (Extra-Trees) Ensemble"},
          {description: "Boosting – AdaBoost (Adaptive Boosting), Gradient Boosting"},
          {description: "Machine (GBM), XGBoost (Extreme Gradient Boosting)"}
        ]
      },
      {
        id: 14,
        title: "Chapter 11: Unsupervised Learning – Clustering",
        content: [
          {description: "Connectivity- based Clustering using Hierarchical Clustering."},
          {description: "Ward’s Agglomerative Hierarchical Clustering"},
          {description: "K-Means Clustering"},
          {description: "Elbow Method and Silhouette Analysis"}
        ]
      },
      {
        id: 15,
        title: "Chapter 12: Unsupervised Learning – Dimensionality Reduction",
        content: [
          {description: "Linear Principal Component Analysis (PCA) reduction."},
          {description: "Kernel PCA"},
          {description: "Linear Discriminant Analysis (LDA) on Supervised Data"}
        ]
      },
      {
        id: 16,
        title: "Chapter 13: Advance NLP with deep-learning overview",
        content: [
          {description: "Computational Linguistic."},
          {description: "History of NLP."},
          {description: "Why NLP."},
          {description: "Use of NLP"},
          {description: "NLP Components"},
          {description: "NLP Ambiguity"},
          {description: "Lexical Ambiguity"},
          {description: "Syntactic Ambiguity"},
          {description: "Referential Ambiguity"},
          {description: "Natural Language Understanding"},
          {description: "Natural Language Generation"},
          {description: "Text Planning"},
          {description: "Sentence Planning"},
          {description: "Text Realization"}
        ]
      },
      {
        id: 17,
        title: "Chapter 14: Feature Engineering",
        content: [
          {description: "Filter Methods"},
          {description: "Wrapper Methods"},
          {description: "Embedded Methods"}
        ]
      },
      {
        id: 18,
        title: "Chapter 15: Neural Network",
        content: [
          {description: "A Simple Perception"},
          {description: "Neural Network overview and its use case."},
          {description: "Various Neural Network architect overview."},
          {description: "Multilayer Network"},
          {description: "Loss Functions."},
          {description: "The Learning Mechanism."},
          {description: "Forward and Backward Propagation."},
          {description: "Gradient Descent"},
          {description: "DL algorithms- ANN, CNN"}
        ]
      }
    ]
  },
  {
    name: "Advanced Data Analytics",
    slug: "data-analytics",
    icon:'fa-solid fa-c',
    
    mode: "Online & Offline & Hybrid",
    duration: "6 Months",
    logo:'10.png',
    description:
    "This Data Analytics course covers SQL, Excel, Power BI, Tableau, Python, and Git to help you analyze, visualize, and interpret data effectively. The course is designed with hands-on projects and real-world use cases to make you industry-ready.",
    modules: [
      {
        id: 1,
        title: "Advanced Python",
        content: [
          { description: "Introduction to Python", type:"heading" },
          { description: "What is Python, and the history of Python?" },
          { description: "Unique features of Python" },
          { description: "Install Python and Environment Setup" },
          { description: "First Python Program" },
          { description: "Python Identifiers, Keywords, and Indentation" },
          { description: "Comments and documentation in Python" },
          { description: "Command line arguments" },
          { description: "Getting User Input" },
          { description: "What are variables?" },
          { description: "Week 1 Assignments" },

          { description: "Control Statements", type:"heading" },
          { description: "If-else" },
          { description: "if-elif-else lader" },
          { description: "while loop" },
          { description: "for loop" },
          { description: "break" },
          { description: "continue" },
          { description: "pass" },
          { description: "return" },

          { description: "Functions in Python", type:"heading" },
          { description: "Introduction to functions" },
          { description: "Functions and Scope" },
          { description: "Types of functions" },
          { description: "Declaration of Function in Python" },
          { description: "Exercise on functions" },

          { description: "Lists in Python", type:"heading" },
          { description: "Introduction to List" },
          { description: "Difference between Lists and Arrays" },
          { description: "Methods of Lists" },
          { description: "Problem-solving on List" },
          { description: "Exercise on List" },

          { description: "Tuples in Python", type:"heading" },
          { description: "Introduction to Tuples" },
          { description: "Difference between Lists and Tuples" },
          { description: "Methods of tuples" },
          { description: "Problem-solving on List" },
          { description: "Exercise on tuples" },

          { description: "Strings in Python", type:"heading" },
          { description: "Introduction to strings" },
          { description: "Properties of Python strings" },
          { description: "Types of strings" },
          { description: "Methods of strings" },
          { description: "Exercise on strings" },

          { description: "Sets in Python", type:"heading" },
          { description: "Introduction to sets" },
          { description: "Properties of Python sets" },
          { description: "Types of sets" },
          { description: "Methods of sets" },
          { description: "Exercise on sets" },

          { description: "Dictionaries in Python", type:"heading" },
          { description: "Introduction to Dictionaries" },
          { description: "Properties of Python Dictionaries" },
          { description: "Methods of Dictionaries" },
          { description: "Exercise on Dictionaries" },

          { description: "Introduction to Expression-Oriented Programming (EOP)", type:"heading" },
          { description: "Types of function parameters" },
          { description: "Iterators and Generators" },
          { description: "Introduction to anonymous (Lambda) functions in Python" },
          { description: "Use of anonymous (Lambda) functions" },
          { description: "Introduction to List Comprehensions" },
          { description: "Introduction to Set Comprehensions" },
          { description: "Introduction to Dictionary Comprehensions" },
          { description: "Introduction to Generator Comprehensions" },
          { description: "Introduction and use of Python built-in functions" },
          { description: "Exercise on EOP" },

          { description: "Exception Handling in Python", type:"heading" },
          { description: "What is an Exception" },
          { description: "Compile-time errors" },
          { description: "Runtime Errors" },
          { description: "Difference between Warnings and Exceptions" },
          { description: "The necessity of handling an exception" },
          { description: "try-except-finally" },
          { description: "try-except-else" },
          { description: "raising an exception" },
          { description: "Python standard exceptions" },
          { description: "User-Defined Exceptions" },

          { description: "Input and Output in Python", type:"heading" },
          { description: "Introduction to files" },
          { description: "Difference between files and databases" },
          { description: "Operations on files" },
          { description: "Modes of files" },
          { description: "Methods of files" },
          { description: "Exercise on file" },

          { description: "Python Object Serialization", type:"heading" },
          { description: "Introduction to serialization" },
          { description: "Introduction to the Pickle library" },
          { description: "Difference between Pickle and JSON" },
          { description: "Methods of the Pickle library" },
          { description: "Exercise on Pickle" },

          { description: "DB-API using SQLite3 Databases in Python", type:"heading" },
          { description: "Python SQLite3 Database Access" },
          { description: "Create Database Connection" },
          { description: "CREATE, INSERT, READ, UPDATE, and DELETE Operations" },
          { description: "DML and DDL Operations with Databases" },
          { description: "Types of database keys" },
          { description: "Performing Transactions" },
          { description: "Handling Database Errors" },

          {description: "Decorators in Python", type:"heading"},
          {description: "Everything in Python is an object"},
          {description: "Defining functions within functions (Nested Functions)"},
          {description: "Returning functions from within functions"},
          {description: "Giving a function as an argument to another function"},
          {description: "Writing your first decorator"},
          {description: "Decorators with Arguments"},

          {description: "Regular Expressions (re module) in Python", type:"heading"},
          {description: "What are regular expressions?"},
          {description: "Why, where, when to use regex"},
          {description: "Declaration of regex"},
          {description: "Wildcard characters in regex"},
          {description: "Methods of regex"},
          {description: "Extended Regular Expressions"},

          { description: "Introduction to Object-Oriented Programming", type:"heading" },
          { description: "Introduction to OOP" },
          { description: "Special methods of Python" },
          { description: "The self variable" },
          { description: "Pillars of OOP (Inheritance, Polymorphism, Encapsulation, Data Abstraction)" },
          { description: "Difference between Methods and Functions" },
          { description: "Types of variables" },
          { description: "Types of Methods" },
          { description: "1. Instance Methods" },
          { description: "2. Class methods" },
          { description: "3. Static methods" },
          { description: "Destroying Objects" },
          { description: "Abstract Methods and Abstract Classes" },
          { description: "Exercise on OOP" },

          {description: "Web Scraping in Python"},
          {description: "Introduction to Data Crawling using Python"},
          {description: "Introduction to Beautifulsoup library"},
          {description: "Introduction to urllib, requests library"},
          {description: "Project 1: Live application on web scrapping"},

          { description: "Data Analysis Using Python", type:"heading" },
          { description: "NumPy" },
          { description: "1. Introduction to NumPy" },
          { description: "2. Difference between Python Lists and NumPy Arrays" },
          { description: "3. Creating arrays" },
          { description: "4. Using Arrays and Scalars" },
          { description: "5. Indexing Arrays" },
          { description: "6. Array Transposition" },
          { description: "7. Universal Array Functions" },
          { description: "8. Array Processing" },
          { description: "9. Array Input and Output" },
          { description: "10. Exercise on NumPy" },

          { description: "Pandas" },
          { description: "1. Introduction to Pandas" },
          { description: "2. Where is it used?" },
          { description: "3. Index objects" },
          { description: "4. Data Structures of Pandas" },
          { description: "5. Series" },
          { description: "6. DataFrame" },
          { description: "7. Reindex" },
          { description: "8. Drop Entry" },
          { description: "9. Selecting Entries" },
          { description: "10. Data Alignment" },
          { description: "11. Rank and Sort" },
          { description: "12. loc and iloc indexing" },
          { description: "13. Summary Statistics" },
          { description: "14. Handling Missing Data" },
          { description: "15. Index Hierarchy" },
          { description: "16. Exercise on Pandas" },

          { description: "Data Visualization : Matplotlib" },
          { description: "1. Introduction to Data Visualization" },
          { description: "2. Introduction to Matplotlib" },
          { description: "3. Types of plots in Matplotlib" },
          { description: "4. 3D plotting with Matplotlib" },
          { description: "5. Basic and Specialized Visualization Tools" }
        ]
      },
      {
        id: 2,
        title: "Advanced Excel",
        content: [
          { description: "Advanced Excel" },
          { description: "Microsoft Excel Introduction", type:"heading" },
          { description: "Basic Microsoft Excel " },
          { description: "Data Entry in Excel" },
          { description: "Basic Formulas in Excel" },
          { description: "Advance Conditional Formatting" },
          { description: "IF Condition Formulas" },
          { description: "Data Formatting Options" },
          { description: "Sheet Options of Excel" },
          { description: "Assignment on IF Formula" },

          { description: "Excel Data Management Tools", type:"heading"  },
          { description: "Sorting Data in Excel" },
          { description: "Filtering Data in Excel" },
          { description: "Advance Filter" },
          { description: "Paste Special in Excel" },
          { description: "Goto Special in Excel" },
          { description: "Find and Replace in Excel" },
          { description: "Flash Fill" },
          { description: "Text to Columns and Remove Duplicates & Consolidate" },
          { description: "Data Validation" },
          { description: "What if Analysis - Scenario Manager, Goal Seek, Data Table" },
          { description: "Group, Ungroup and Subtotal" },
          { description: "Assignment related Subtotal, Data table" },

          { description: "Mastering Pivot Tables", type:"heading"  },
          { description: "Introduction of Pivot Table" },
          { description: "Pivot Chart and Design" },
          { description: "Slicer in Pivot table" },
          { description: "Timeline in Pivot table" },
          { description: "Top Bottom analysis" },
          { description: "Pivot Table analyse Options" },
          { description: "Calculated Field" },
          { description: "Dynamic Range" },
          { description: "Auto refresh" },
          { description: "Pivot on Multiple Sheet" },
          { description: "Show Values as in Pivot Table" },
          { description: "Recommended Pivot Table" },
          { description: "Pivot Table Assignment" },

          { description: "Excel Lookup Formulas Simplified", type:"heading"  },
          { description: "Vlookup Formula Introduction" },
          { description: "Fetching info from Large Data" },
          { description: "Vlookup with Match" },
          { description: "Use of Approx. Match" },
          { description: "Vlookup Formula - Find Matching" },
          { description: "Double Vlookup" },
          { description: "Match and Index" },
          { description: "Assignment on Vlookup Formula" },
          { description: "Xlooukp Formula Mastery" },
          { description: "Count, CountA, CountIF Formulas" },
          { description: "SumIF and SumIFS Formulas" },
          { description: "AverageIF, MAXIFS, MINIFS" },
          { description: "Formulas for Insights - SORT, FILTER, TAKE" },
          { description: "Assignment on - SORT, FILTER, TAKE" },
          { description: "Useful Text Formulas" },
          { description: "Date formulas for Analysis" },
          { description: "Financial formulas for Analysis" },
          { description: "Excel Project -End to End Dashboard" }
        ]

      },
      {
        id: 3,
        title: "Power BI Mastery",
        content: [
          { description: "Microsoft Power BI Introduction & ELT", type:"heading" },
          { description: "Power BI Introduction" },
          { description: "How to Load Data in Power BI" },
          { description: "Transform Data" },
          { description: "Canvas & Page Settings" },
          { description: "Let's Start Visualization" },
          { description: "Format Visuals" },
          { description: "Format Visuals - General" },
          { description: "Line, Area, and Ribbon Chart" },
          { description: "View and Save Visuals as PDF" },
          { description: "Water and Funnel Chart" },
          { description: "Scatter Chart" },
          { description: "Pie, Donut, and Tree Map Chart" },
          { description: "Map, Filled Map, Shape Map" },
          { description: "Azure Map" },
          { description: "Gauge Chart" },
          { description: "KPI - Key Performance Indicator" },
          { description: "Table Visual" },
          { description: "Matrix Visual" },
          { description: "Decomposition Tree" },
          { description: "Key Influencer and Smart Narrative" },
          { description: "Conditional Formatting" },

          { description: "Power BI Service and Reporting", type:"heading" },
          { description: "How to Publish Report on Power BI Service" },
          { description: "Filter Options in Power BI" },
          { description: "Drill Through in Power BI" },
          { description: "Drill Through with Button" },
          { description: "Edit Interaction in Power BI" },
          { description: "Use Cards as Text Cards" },
          { description: "Bookmarks Pane" },
          { description: "Sync Slicer & Performance Analyzer" },
          { description: "Understanding Data Model" },
          { description: "What is DATA Model" },
          { description: "Data Concepts - Data Normalization" },
          { description: "Managing Relationships" },
          { description: "Filter Flow & 2-Way Filter" },
          { description: "Properties in Model" },

          { description: "DAX Functions and Formula", type:"heading" },
          { description: "DAX Functions Introduction" },
          { description: "Implicit Vs. Explicit Measures" },
          { description: "Ways to Adding Columns and Measures" },
          { description: "Quick Measures and Suggestions" },
          { description: "DAX Syntax" },
          { description: "DAX Operators" },
          { description: "DAX - Date & Time Functions" },
          { description: "Logical and Conditional Functions" },
          { description: "Text Functions" },
          { description: "Calculate DAX Formula" },
          { description: "Sum Vs SUMX" },
          { description: "RANX DAX In Power BI" },
          { description: "Difference Between CountX and CountAX" },
          { description: "Create Own Calendar using Formula" },
          { description: "MTD, QTD, YTD Functions" },
          { description: "Same Period Last Year DAX Function" },
          { description: "Previous Month, Quarter, Year DAX" },
          { description: "DateADD DAX Function" },
          { description: "DATESBETWEEN and DATESINPERIOD DAX" },
          { description: "DAX Function - Related" },
          { description: "HAS ONE VALUE - DAX Function" },
          { description: "Selected Value and Switch DAX" },
          { description: "What are Variables in DAX" },
          { description: "Practical Use of Variables" },
          { description: "Calendar DAX Formula in Power BI" },

          { description: "Additional Topics and Tips", type:"heading" },
          { description: "How to use Power BI free for two Months" },
          { description: "How to Publish Report on Web" },
          { description: "New Slicer in Power BI" },
          { description: "How to connect SQL Server data to Power BI" },
          { description: "Export Data into excel from Power BI file" },
          { description: "Create unique layout" },
          { description: "Add image without Image visual" },
          { description: "Add image as tooltip" },
          { description: "Text Functions" },
          { description: "Calculate DAX Formula" }
        ]

      },


      {
        id: 4,
        title: "Advanced SQL Mastery",
        content: [
          { description: "Introduction Of SQL", type:"heading" },
          { description: "Installation Of SQL (SQLite & Postgres)" },
          { description: "Interface of pgAdmin IDE" },
          { description: "Types of Commands In SQL" },
          { description: "Database and Table Management" },
          { description: "Create Database And Table" },
          { description: "Simple Way To Create Table" },
          { description: "Data Types & Constraints in SQL" },
          { description: "Use of Alter Command in SQL" },
          { description: "Inserting Data into Table" },
          { description: "Deleting Data From Table" },

          { description: "SQL Operators and Date Functions in SQL", type:"heading" },
          { description: "Logical Operators and Detail use" },
          { description: "Use of NOT NULL and NOT IN" },
          { description: "Use of UNION Operator" },
          { description: "Group By and Having in SQL" },
          { description: "Basic Date Functions in SQL" },
          { description: "Date Functions in SQL" },
          { description: "Use of AGE Function" },
          { description: "String Functions in SQL" },

          { description: " 1. Joins and PL SQL" },
          { description: "2. PL SQL Block Structure" },
          { description: "3. Stored Procedures" },
          { description: "4. Functions" },
          { description: "5. Triggers" },
          { description: "6. Cursors" },

          { description: "Sub Query in SQL" },
          { description: "Sub Query with IN Operator" },
          { description: "Assignment on Sub Query" },

          { description: "Window Functions in SQL", type:"heading" },
          { description: "Aggregate Window Functions" },
          { description: "Analytic Window Functions" },
          { description: "Ranking Window Functions" },
          { description: "Assignment on Window Functions" },

          { description: "Case Statement in SQL" },
          { description: "Case Statement - Multiple Statement" },
          { description: "Case with Where Clause" },
          { description: "Case with Values only" }
        ]

      },

      

      

      {
        id: 5,
        title: "Tableau Mastery",
        content: [
          { description: "Tableau Basics", type:"heading" },
          { description: "What is Tableau?" },
          { description: "Tableau Desktop vs Public vs Server vs Cloud" },
          { description: "Self-Service BI vs Traditional BI" },
          { description: "Tableau Ecosystem Overview" },
          { description: "Installing Tableau (Desktop & Public)" },
          { description: "Connecting to Sample Datasets (Excel, CSV, Google Sheets)" },
          { description: "Getting Started with Tableau" },
          { description: "Tableau Interface Overview" },
          { description: "Workbook, Data Pane, Canvas" },
          { description: "Dimensions vs Measures" },
          { description: "Blue vs Green Pills" },
          { description: "Data Pane, Cards, Shelves, Marks, and Menus" },

          { description: "Connecting Data Sources" },
          { description: "Flat Files (Excel, CSV, Google Sheets)" },
          { description: "Databases (SQL Server, PostgreSQL, MySQL)" },
          { description: "Web Data Connector (Intro)" },
          { description: "Live vs Extract Connections" },

          { description: "Data Preparation & Cleaning", type:"heading" },
          { description: "Data Interpreter" },
          { description: "Clean Messy Excel Files" },
          { description: "Recognize Headers, Hidden Rows, Merged Cells" },

          { description: "Joins & Blends" },
          { description: "Inner, Left, Right, Full Joins" },
          { description: "Relationships vs Joins" },
          { description: "Data Blending Use Cases" },

          { description: "Pivoting & Splitting Columns" },
          { description: "Unpivoting Wide Datasets" },
          { description: "Splitting Fields into Subcomponents" },

          { description: "Calculated Fields" },
          { description: "Custom Columns Using Formulas" },
          { description: "IF/THEN, CASE, DATE Functions" },
          { description: "Boolean Flags and Category Buckets" },

          { description: "Visualizations – Basic to Advanced", type:"heading" },

          { description: "Basic Charts" },
          { description: "Bar Chart, Line Chart, Area Chart" },
          { description: "Pie Chart, Donut Chart, Tree Map" },
          { description: "Maps (Symbol + Filled)" },
          { description: "Tables and Cross Tabs" },

          { description: "Intermediate Charts" },
          { description: "Dual-Axis (Combo Charts)" },
          { description: "Heatmaps" },
          { description: "Scatter Plots + Trend Lines" },
          { description: "Histogram + Box Plot" },

          { description: "Advanced Visualizations" },
          { description: "Funnel Chart" },
          { description: "Gantt Chart" },
          { description: "Waterfall Chart, KPI Cards" },
          { description: "Radar Chart (Using Calculated Fields)" },

          { description: "Dashboard Design & Interactivity", type:"heading" },
          { description: "Building Dashboards" },
          { description: "Combining Multiple Sheets" },
          { description: "Device-Specific Dashboards (Mobile vs Desktop)" },
          { description: "Floating vs Tiled Layout" },

          { description: "Adding Interactivity" },
          { description: "Filters, Parameters, Highlights" },
          { description: "Show/Hide Containers" },
          { description: "Button Navigation & Sheet Swapping" },
          { description: "Actions: Filter, URL, Highlight, Set" },

          { description: "Storytelling with Tableau" },
          { description: "Creating a Story with Multiple Dashboards" },
          { description: "Annotating and Explaining Insights" },
          { description: "Use Case: Management Summary Dashboards" },

          { description: "Analytics in Tableau", type:"heading" },
          { description: "Aggregations & Granularity" },
          { description: "AVG, SUM, COUNT, MIN, MAX" },
          { description: "Aggregating Across Categories" },
          { description: "Data Densification" },

          { description: "Table Calculations" },
          { description: "Running Total, % of Total, Moving Average" },
          { description: "INDEX(), RANK(), FIRST()" },
          { description: "Nested Table Calcs" },

          { description: "Level of Detail (LOD) Expressions" },
          { description: "FIXED, INCLUDE, EXCLUDE" },
          { description: "Compare with Table Calcs" },
          { description: "Use Cases: Cohort Analysis, Multi-Level Aggregations" },

          { description: "Forecasting & Trend Lines" },
          { description: "Linear Trends" },
          { description: "Predictive Analytics (Basic)" },
          { description: "Built-In Forecast Model" },

          { description: "Dashboard Publishing & Sharing", type:"heading" },
          { description: "Publishing to Tableau Public" },
          { description: "Create a Profile and Upload Dashboards" },
          { description: "Workbooks vs Data Sources" },
          { description: "Dashboard design principles" },

          { description: "Tableau Integration & Extensions" },
          { description: "Tableau + Excel / Google Sheets" },
          { description: "Real-Time Updates" },
          { description: "Parameters Connected to Spreadsheets" },
          { description: "Tableau + SQL / Live Databases" },
          { description: "Writing Custom SQL in Tableau" },
          { description: "Use Case: Sentiment Analysis, Forecast Model" },

          { description: "Real-World Projects", type:"heading" },
          { description: "Project 1: Sales Performance Dashboard" },
          { description: "Project 2: HR Analytics Dashboard" },
          { description: "Project 3: Financial Reporting Suite" }
        ]

      },

      
      {
        id: 6,
        title: "Git & GitHub for Version Control",
        content: [
          { description: "Introduction to Version Control", type:"heading" },
          { description: "What is version control?" },
          { description: "Why version control is important for data analysts" },
          { description: "Centralized vs. distributed version control systems" }, 

          { description: "Git Basics", type:"heading" },
          { description: "Installing Git and setting up Git configuration" },
          { description: "Git terminology: repository, commit, branch, merge, remote" },
          { description: "Initializing a repository (git init)" },
          { description: "Cloning a repository (git clone)" },
          { description: "Staging and committing changes (git add, git commit)" },
          { description: "Viewing commit history (git log, git status)" },

          { description: "Working with Branches", type:"heading" },
          { description: "Creating and switching branches (git branch, git checkout)" },
          { description: "Merging branches (git merge)" },
          { description: "Understanding merge conflicts and how to resolve them" },

          { description: "Remote Repositories with GitHub", type:"heading" },
          { description: "Creating a GitHub account" },
          { description: "Creating and cloning GitHub repositories" },
          { description: "Connecting local repo to GitHub (git remote add origin)" },
          { description: "Pushing and pulling changes (git push, git pull)" },
          { description: "Forking and starring repositories" },

          { description: "GitHub as a Portfolio for Data Analysts", type:"heading" },
          { description: "Creating a professional GitHub profile" },
          { description: "Hosting Tableau Public or Power BI links on GitHub README" },
          { description: "Writing effective README files for data projects" },
          { description: "Showcasing capstone projects in a structured way" }
        ]
      }

    ]
  },
  {
    name: "Full Stack Node.js",
    slug: "full-stack-nodejs",
    icon: "fa-brands fa-node-js",

    mode: "Online & Offline & Hybrid",
    duration: "6 Months",
    logo: "fullstactnode.png",

    description:
    "This Full Stack Node.js course covers HTML, CSS, JavaScript, React, Node.js, Express, MongoDB, SQL, REST APIs, authentication, deployment, and Git. Designed with real-world projects to make you job-ready as a Full Stack Developer.",

    modules: [
      {
        id: 1,
        title: "Web Fundamentals (HTML, CSS, JavaScript)",
        content: [
          { description: "Introduction to Web Development", type: "heading" },
          { description: "How the Web Works (Client–Server Model)" },
          { description: "HTTP, HTTPS, Browsers, DNS" },

          { description: "HTML5", type: "heading" },
          { description: "HTML Structure & Tags" },
          { description: "Forms, Inputs, Tables" },
          { description: "Semantic HTML" },

          { description: "CSS3", type: "heading" },
          { description: "CSS Selectors & Box Model" },
          { description: "Flexbox & Grid Layout" },
          { description: "Responsive Design & Media Queries" },
          { description: "Bootstrap / Tailwind Basics" },

          { description: "JavaScript Basics", type: "heading" },
          { description: "Variables, Data Types, Operators" },
          { description: "Conditional Statements & Loops" },
          { description: "Functions & Scope" },
          { description: "Arrays & Objects" },
          { description: "DOM Manipulation" },
          { description: "Mini Project: Responsive Website" }
        ]
      },

      {
        id: 2,
        title: "Advanced JavaScript (ES6+)",
        content: [
          { description: "JavaScript Advanced Concepts", type: "heading" },
          { description: "Execution Context & Call Stack" },
          { description: "Hoisting & Closures" },
          { description: "Arrow Functions" },
          { description: "Spread & Rest Operators" },
          { description: "Destructuring" },

          { description: "Asynchronous JavaScript", type: "heading" },
          { description: "Callbacks" },
          { description: "Promises" },
          { description: "Async / Await" },
          { description: "Event Loop" },

          { description: "Error Handling & Debugging" },
          { description: "Mini Project: API Data Fetch App" }
        ]
      },

      {
        id: 3,
        title: "Frontend Development with React",
        content: [
          { description: "React Fundamentals", type: "heading" },
          { description: "What is React & Why React?" },
          { description: "JSX & Components" },
          { description: "Props & State" },

          { description: "React Hooks", type: "heading" },
          { description: "useState" },
          { description: "useEffect" },
          { description: "useContext" },
          { description: "Custom Hooks" },

          { description: "Routing & State Management", type: "heading" },
          { description: "React Router" },
          { description: "Lifting State Up" },
          { description: "Basic Redux / Context API" },

          { description: "API Integration" },
          { description: "Axios / Fetch" },
          { description: "Project: React Dashboard App" }
        ]
      },

      {
        id: 4,
        title: "Node.js & Express.js Backend",
        content: [
          { description: "Node.js Basics", type: "heading" },
          { description: "What is Node.js?" },
          { description: "Node Architecture" },
          { description: "NPM & Package Management" },

          { description: "Express.js", type: "heading" },
          { description: "Creating Server with Express" },
          { description: "Routing & Middleware" },
          { description: "Request & Response Lifecycle" },

          { description: "REST API Development", type: "heading" },
          { description: "REST Principles" },
          { description: "CRUD Operations" },
          { description: "Postman Testing" },

          { description: "Project: REST API with Express" }
        ]
      },

      {
        id: 5,
        title: "Database Management (MongoDB & SQL)",
        content: [
          { description: "MongoDB Basics", type: "heading" },
          { description: "NoSQL vs SQL" },
          { description: "MongoDB Collections & Documents" },
          { description: "CRUD Operations" },

          { description: "Mongoose ODM", type: "heading" },
          { description: "Schemas & Models" },
          { description: "Relationships & Population" },

          { description: "SQL Fundamentals", type: "heading" },
          { description: "Tables, Keys & Constraints" },
          { description: "Joins & Subqueries" },

          { description: "Project: Database-Driven App" }
        ]
      },

      {
        id: 6,
        title: "Authentication & Security",
        content: [
          { description: "User Authentication", type: "heading" },
          { description: "JWT Authentication" },
          { description: "Password Hashing (bcrypt)" },
          { description: "Role-Based Access Control" },

          { description: "Security Best Practices", type: "heading" },
          { description: "CORS" },
          { description: "Environment Variables" },
          { description: "Preventing Common Attacks" },

          { description: "Project: Secure Login System" }
        ]
      },

      {
        id: 7,
        title: "Git, GitHub & Deployment",
        content: [
          { description: "Version Control with Git", type: "heading" },
          { description: "Git Basics & Workflow" },
          { description: "Branching & Merging" },

          { description: "GitHub", type: "heading" },
          { description: "Repositories & Pull Requests" },
          { description: "Project Hosting on GitHub" },

          { description: "Deployment", type: "heading" },
          { description: "Frontend Deployment (Netlify / Vercel)" },
          { description: "Backend Deployment (Render / Railway)" },
          { description: "Environment Configuration" }
        ]
      },

      {
        id: 8,
        title: "Capstone Projects",
        content: [
          { description: "Project 1: Full Stack Blog Application" },
          { description: "Project 2: E-Commerce Web App" },
          { description: "Project 3: Admin Dashboard with Analytics" },
          { description: "Resume & Interview Preparation" }
        ]
      }
    ]
  },
  {
    name: "Generative AI Engineer",
    slug: "generative-ai",
    icon: "fa-solid fa-brain",

    mode: "Online & Offline & Hybrid",
    duration: "6 Months",
    logo: "generative_ai.png",

    description:
    "This Generative AI course covers Python, Machine Learning fundamentals, Large Language Models (LLMs), Prompt Engineering, LangChain, RAG systems, vector databases, fine-tuning, and real-world GenAI applications. Designed with hands-on projects to make you job-ready as a Generative AI Engineer.",

    modules: [
      {
        id: 1,
        title: "Python for AI & Data Handling",
        content: [
          { description: "Introduction to Python for AI", type: "heading" },
          { description: "Python Basics Refresher" },
          { description: "Data Types, Control Flow, Functions" },
          { description: "List, Dict & Set Comprehensions" },
          { description: "Exception Handling & File Handling" },

          { description: "Data Handling Libraries", type: "heading" },
          { description: "NumPy for Numerical Computing" },
          { description: "Pandas for Data Analysis" },
          { description: "Data Cleaning & Preprocessing" },
          { description: "Working with CSV, JSON, APIs" },

          { description: "Project: Data Processing Pipeline" }
        ]
      },

      {
        id: 2,
        title: "Machine Learning Fundamentals",
        content: [
          { description: "Introduction to Machine Learning", type: "heading" },
          { description: "Types of ML (Supervised, Unsupervised, Reinforcement)" },
          { description: "Train-Test Split & Model Evaluation" },

          { description: "Supervised Learning", type: "heading" },
          { description: "Linear & Logistic Regression" },
          { description: "Decision Trees & Random Forest" },
          { description: "KNN & Naive Bayes" },

          { description: "Unsupervised Learning", type: "heading" },
          { description: "Clustering (K-Means, Hierarchical)" },
          { description: "Dimensionality Reduction (PCA)" },

          { description: "Model Evaluation", type: "heading" },
          { description: "Accuracy, Precision, Recall, F1-Score" },
          { description: "Cross Validation" },

          { description: "Project: ML Prediction System" }
        ]
      },

      {
        id: 3,
        title: "Deep Learning & Neural Networks",
        content: [
          { description: "Neural Network Fundamentals", type: "heading" },
          { description: "Perceptron & Activation Functions" },
          { description: "Forward & Backpropagation" },

          { description: "Deep Learning Frameworks", type: "heading" },
          { description: "Introduction to TensorFlow & PyTorch" },
          { description: "Building Neural Networks" },

          { description: "Computer Vision Basics", type: "heading" },
          { description: "CNN Architecture" },
          { description: "Image Classification" },

          { description: "Project: Image Classification Model" }
        ]
      },

      {
        id: 4,
        title: "Natural Language Processing (NLP)",
        content: [
          { description: "NLP Fundamentals", type: "heading" },
          { description: "Text Preprocessing & Tokenization" },
          { description: "Stemming & Lemmatization" },

          { description: "Word Representations", type: "heading" },
          { description: "Bag of Words & TF-IDF" },
          { description: "Word2Vec & GloVe" },

          { description: "Text Models", type: "heading" },
          { description: "Text Classification" },
          { description: "Named Entity Recognition" },
          { description: "Sentiment Analysis" },

          { description: "Project: NLP Text Analyzer" }
        ]
      },

      {
        id: 5,
        title: "Large Language Models (LLMs)",
        content: [
          { description: "Introduction to LLMs", type: "heading" },
          { description: "What are LLMs and How They Work?" },
          { description: "Transformers Architecture" },
          { description: "Attention Mechanism" },

          { description: "Popular LLMs", type: "heading" },
          { description: "GPT, LLaMA, Claude, Gemini Overview" },
          { description: "OpenAI & Hugging Face Ecosystem" },

          { description: "Inference & Usage", type: "heading" },
          { description: "Tokens, Context Window" },
          { description: "Temperature, Top-p, Top-k" },

          { description: "Project: LLM-powered Text Generator" }
        ]
      },

      {
        id: 6,
        title: "Prompt Engineering & RAG",
        content: [
          { description: "Prompt Engineering", type: "heading" },
          { description: "Zero-shot & Few-shot Prompting" },
          { description: "Chain-of-Thought Prompting" },
          { description: "Prompt Optimization Techniques" },

          { description: "Retrieval-Augmented Generation (RAG)", type: "heading" },
          { description: "What is RAG and Why It Matters?" },
          { description: "Embeddings & Similarity Search" },
          { description: "Vector Databases (FAISS, Pinecone, Chroma)" },

          { description: "Project: RAG-based Chatbot" }
        ]
      },

      {
        id: 7,
        title: "LangChain, Agents & Tools",
        content: [
          { description: "LangChain Fundamentals", type: "heading" },
          { description: "Chains, Prompts, Memory" },
          { description: "Document Loaders & Text Splitters" },

          { description: "Agents & Tools", type: "heading" },
          { description: "Tool Calling" },
          { description: "Autonomous Agents" },
          { description: "Multi-Agent Systems" },

          { description: "Project: AI Assistant with Tools" }
        ]
      },

      {
        id: 8,
        title: "Fine-Tuning & Custom Models",
        content: [
          { description: "Fine-Tuning LLMs", type: "heading" },
          { description: "When to Fine-Tune vs Prompt?" },
          { description: "PEFT & LoRA Concepts" },

          { description: "Training Pipelines", type: "heading" },
          { description: "Data Preparation for Fine-Tuning" },
          { description: "Model Evaluation & Monitoring" },

          { description: "Project: Domain-Specific AI Model" }
        ]
      },

      {
        id: 9,
        title: "GenAI Deployment & MLOps",
        content: [
          { description: "Serving AI Models", type: "heading" },
          { description: "FastAPI for AI APIs" },
          { description: "Model Inference Optimization" },

          { description: "MLOps & Deployment", type: "heading" },
          { description: "Docker for AI Applications" },
          { description: "Cloud Deployment (AWS / GCP / Azure)" },
          { description: "CI/CD for AI Systems" },

          { description: "Monitoring & Logging", type: "heading" },
          { description: "Latency, Cost & Token Monitoring" },

          { description: "Project: Deployed GenAI Application" }
        ]
      },

      {
        id: 10,
        title: "Capstone Projects & Career Prep",
        content: [
          { description: "Project 1: AI Chatbot (LLM + RAG)" },
          { description: "Project 2: AI Content Generator" },
          { description: "Project 3: AI Search Engine" },
          { description: "Portfolio & GitHub Optimization" },
          { description: "Interview & Resume Preparation" }
        ]
      }
    ]
  },
  {
    name: "AUTOSAR Automotive Embedded Engineer",
    slug: "autosar-embedded",
    icon: "fa-solid fa-car",

    mode: "Online & Offline & Hybrid",
    duration: "3+ Months",
    logo: "genai.png",

    description:
    "This AUTOSAR course covers Embedded C, Automotive ECU fundamentals, Classic AUTOSAR architecture, BSW, MCAL, RTE, OS, communication stacks, diagnostics, and an introduction to Adaptive AUTOSAR. Designed with tool-based workflows and real ECU-level projects for automotive industry readiness.",

    modules: [
      {
        id: 1,
        title: "Programming & Embedded C Fundamentals",
        content: [
          { description: "What is an Embedded System?", type: "heading" },
          { description: "Definition and real-world examples" },
          { description: "Differences between general-purpose and embedded systems" },

          { description: "Embedded Systems in Automotive Domain", type: "heading" },
          { description: "ECUs (Engine, Body, ADAS, Infotainment)" },
          { description: "Role of software in modern vehicles" },

          { description: "Automotive Software Overview", type: "heading" },
          { description: "Bare-metal vs RTOS-based systems" },
          { description: "Introduction to AUTOSAR software stack (high-level view)" },

          { description: "Development Environment Basics", type: "heading" },
          { description: "Cross-compiler concept" },
          { description: "IDE overview (Eclipse, VS Code, etc.)" },

          { description: "Week 1 Assignments" }
        ]
      },
      {
        id: 2,
        title: "C Language Structure & Compilation Process",
        content: [
          { description: "Structure of a C Program", type: "heading" },
          { description: "Header files" },
          { description: "main() function" },
          { description: "Preprocessor directives" },

          { description: "C Compilation Flow", type: "heading" },
          { description: "Preprocessing" },
          { description: "Compilation" },
          { description: "Assembly" },
          { description: "Linking" },

          { description: "Toolchain Overview", type: "heading" },
          { description: "Compiler, linker, loader" },
          { description: "Embedded vs desktop compilation" },

          { description: "Common Compilation Errors & Warnings", type: "heading" },
          { description: "Syntax vs semantic errors" },
          { description: "Importance of warnings in safety-critical code" }
        ]
      },

      {
        id: 3,
        title: "Data Types, Operators & Control Statements",
        content: [
          { description: "Basic Data Types", type: "heading" },
          { description: "int, char, float, double" },
          { description: "Signed vs unsigned" },
          { description: "Size of data types in embedded systems" },

          { description: "Derived & User-Defined Types (intro)", type: "heading" },
          { description: "Arrays, structures (basic idea)" },

          { description: "Operators", type: "heading" },
          { description: "Arithmetic, relational, logical" },
          { description: "Assignment and conditional operators" },

          { description: "Control Statements", type: "heading" },
          { description: "if-else if-else ladder" },
          { description: "for loop" },
          { description: "while loop" },
          { description: "do-while loop" },
          { description: "switch cases" },

          { description: "Best practices for deterministic loops" }
        ]
      },
      {
        id: 4,
        title: "Functions, Recursion & Modular Programming",
        content: [
          { description: "Function Basics", type: "heading" },
          { description: "Function declaration, definition, calling" },
          { description: "Parameter passing (by value)" },

          { description: "Return Types and Scope", type: "heading" },
          { description: "Local vs global variables" },
          { description: "static variables in functions" },

          { description: "Modular Programming", type: "heading" },
          { description: "Header (.h) and source (.c) files" },
          { description: "Code separation and reuse" },

          { description: "Recursion", type: "heading" },
          { description: "Concept and examples" },
          { description: "Why recursion is generally avoided in embedded systems" },

          { description: "Problem-solving on Functions" },
          { description: "Exercise on functions" }
        ]
      },

      {
        id: 5,
        title: "Memory-level programming used heavily in AUTOSAR",
        content: [
          { description: "Arrays", type: "heading" },
          { description: "One-dimensional and multi-dimensional arrays" },
          { description: "Passing arrays to functions" },

          { description: "Pointers", type: "heading" },
          { description: "Pointer basics and syntax" },
          { description: "Pointer arithmetic" },
          { description: "Pointers vs arrays" },

          { description: "Structures", type: "heading" },
          { description: "Defining and accessing structures" },
          { description: "Nested structures" },
          { description: "Structures in hardware abstraction" },

          { description: "Unions", type: "heading" },
          { description: "Difference between structure and union" },
          { description: "Memory optimization use cases" },

          { description: "Enums", type: "heading" },
          { description: "Enumerations for readable and safe code" },
          { description: "Use in state machines" },

          { description: "Exercise on memory level programming" }
        ]
      },
      {
        id: 6,
        title: "Understanding of memory usage for reliable embedded applications",
        content: [
          { description: "Embedded Memory Architecture", type: "heading" },
          { description: "Flash" },
          { description: "RAM" },
          { description: "EEPROM overview" },

          { description: "Stack Memory", type: "heading" },
          { description: "Function calls and local variables" },
          { description: "Stack overflow risks" },

          { description: "Heap Memory", type: "heading" },
          { description: "Dynamic memory allocation (malloc, free)" },
          { description: "Why dynamic memory is avoided in AUTOSAR" },

          { description: "Static Memory", type: "heading" },
          { description: "Global and static variables" },
          { description: "Lifetime and memory placement" },

          { description: "Memory Optimization Techniques", type: "heading" },
          { description: "Reducing RAM usage" },
          { description: "Avoiding fragmentation" }
        ]
      },
      {
        id: 7,
        title: "Bitwise Operations & Register Access",
        content: [
          { description: "Bitwise Operators", type: "heading" },
          { description: "AND, OR, XOR, NOT" },
          { description: "Left and right shift operations" },

          { description: "Bit Masking Techniques", type: "heading" },
          { description: "Set, clear, toggle bits" },
          { description: "Reading specific bits" },

          { description: "Hardware Register Access", type: "heading" },
          { description: "Memory-mapped I/O concept" },
          { description: "Volatile keyword usage" },

          { description: "Practical Embedded Examples", type: "heading" },
          { description: "LED control simulation" },
          { description: "Register configuration patterns" },

          { description: "Exercise on operators" }
        ]
      },
      {
        id: 8,
        title: "MISRA C Overview & Safe Coding Practices (Write automotive-grade, safety-compliantC code)",
        content: [
          { description: "Why MISRA C?", type: "heading" },
          { description: "Safety, reliability, and maintainability" },
          { description: "Automotive compliance requirements" },

          { description: "MISRA C Guidelines Overview", type: "heading" },
          { description: "Mandatory vs advisory rules" },
          { description: "Common rule violations" },

          { description: "Safe Coding Practices", type: "heading" },
          { description: "Avoiding undefined behavior" },
          { description: "Type safety and explicit casting" },

          { description: "Code Quality Techniques", type: "heading" },
          { description: "Defensive programming" },
          { description: "Code reviews and static analysis tools" }
        ]
      },
      {
        id: 9,
        title: "Automotive Embedded Systems Fundamentals",
        content: [
          { description: "Automotive Electronics Overview", type: "heading" },
          { description: "Evolution of Automotive Electronics" },
          { description: "Mechanical → Electro-mechanical → Software-defined vehicles" },
          { description: "Growth of ECUs in modern cars" },

          { description: "Key Automotive Domains", type: "heading" },
          { description: "Powertrain" },
          { description: "Body Electronics" },
          { description: "Chassis" },
          { description: "Infotainment" },
          { description: "ADAS & Autonomous Systems" },

          { description: "Role of Embedded Software", type: "heading" },
          { description: "Control logic" },
          { description: "Diagnostics" },
          { description: "Communication between ECUs" },

          { description: "Automotive Standards Introduction", type: "heading" },
          { description: "AUTOSAR (high-level mention)" },
          { description: "ISO 26262 (functional safety – overview)" }
        ]
      },
      {
        id: 10,
        title: "ECU Architecture & Components",
        content: [
          { description: "What is an ECU?", type: "heading" },
          { description: "Definition and examples (Engine ECU, BCM, TCU, ABS)" },

          { description: "ECU Hardware Components", type: "heading" },
          { description: "Microcontroller (MCU)" },
          { description: "Flash, RAM, EEPROM" },
          { description: "Clock and power supply" },
          { description: "External peripherals" },

          { description: "ECU Software Architecture (High Level)", type: "heading" },
          { description: "Application software" },
          { description: "Basic software" },
          { description: "Hardware abstraction" },

          { description: "Bootloader & Startup Sequence", type: "heading" },
          { description: "Power-on reset" },
          { description: "Initialization flow" }
        ]
      },
      {
        id: 11,
        title: "Sensors & Actuators in Vehicles",
        content: [
          { description: "Sensors Overview", type: "heading" },
          { description: "Purpose of sensors in automotive systems" },
          { description: "Analog vs digital sensors" },

          { description: "Common Automotive Sensors", type: "heading" },
          { description: "Temperature" },
          { description: "Pressure" },
          { description: "Speed" },
          { description: "Position (Throttle, Crankshaft)" },
          { description: "Proximity and radar (intro)" },

          { description: "Actuators Overview", type: "heading" },
          { description: "Role of actuators" },
          { description: "Types of actuators" },

          { description: "Common Automotive Actuators", type: "heading" },
          { description: "Motors" },
          { description: "Valves" },
          { description: "Relays" },
          { description: "Injectors" },

          { description: "Sensor-Actuator Interaction", type: "heading" },
          { description: "Control loop basics" },
          { description: "Input → Processing → Output concept" }
        ]
      },
      {
        id: 12,
        title: "Real-Time Constraints in Automotive Systems",
        content: [
          { description: "What is a Real-Time System?", type: "heading" },
          { description: "Hard vs soft real-time systems" },

          { description: "Real-Time Requirements in Automotive", type: "heading" },
          { description: "Deterministic execution" },
          { description: "Predictable response time" },

          { description: "Timing Constraints", type: "heading" },
          { description: "Deadlines" },
          { description: "Latency" },
          { description: "Jitter" },

          { description: "Automotive Examples", type: "heading" },
          { description: "Airbag deployment" },
          { description: "ABS braking" },
          { description: "Engine control timing" },

          { description: "Introduction to Scheduling Concepts", type: "heading" },
          { description: "Tasks and priorities" },
          { description: "Periodic vs event-driven tasks" }
        ]
      },
      {
        id: 13,
        title: "Vehicle E/E (Electrical & Electronic) Architecture",
        content: [
          { description: "What is Vehicle E/E Architecture?", type: "heading" },
          { description: "Definition and purpose" },

          { description: "Traditional Distributed Architecture", type: "heading" },
          { description: "Multiple ECUs per function" },
          { description: "Limitations" },

          { description: "Domain-Based Architecture", type: "heading" },
          { description: "Body, Powertrain, ADAS domains" },

          { description: "Centralized & Zonal Architecture (Modern Trend)", type: "heading" },
          { description: "Central compute units" },
          { description: "Zonal controllers" },

          { description: "Communication Overview (High Level)", type: "heading" },
          { description: "CAN, LIN, FlexRay, Ethernet (intro only)" }
        ]
      },
      {
        id: 14,
        title: "OEM, Tier-1 & Tier-2 Ecosystem Overview",
        content: [
          { description: "Automotive Industry Structure", type: "heading" },
          { description: "How vehicles are developed and supplied" },

          { description: "OEM (Original Equipment Manufacturer)", type: "heading" },
          { description: "Examples (BMW, Mercedes, Tata, Mahindra)" },
          { description: "Role in vehicle design and integration" },

          { description: "Tier-1 Suppliers", type: "heading" },
          { description: "Examples (Bosch, Continental, ZF, Magna)" },
          { description: "ECU and system development responsibility" },

          { description: "Tier-2 Suppliers", type: "heading" },
          { description: "Semiconductor and component providers" },
          { description: "Tool and software vendors" },

          { description: "Software Development Lifecycle in Automotive", type: "heading" },
          { description: "Requirements → Design → Implementation → Testing → Validation" }
        ]
      },
      {
        id: 15,
        title: "Automotive Communication Protocols",
        content: [
          { description: "Introduction to In-Vehicle Networking", type: "heading" },
          { description: "Why In-Vehicle Communication is Needed" },
          { description: "Multiple ECUs working together" },
          { description: "Data sharing between sensors, controllers, and actuators" },

          { description: "Evolution of Vehicle Networking", type: "heading" },
          { description: "Point-to-point wiring limitations" },
          { description: "Bus-based communication advantages" },

          { description: "Types of Automotive Networks", type: "heading" },
          { description: "Low-speed, high-speed, and backbone networks" },

          { description: "Role of Communication in AUTOSAR", type: "heading" },
          { description: "Communication stack overview (high level)" },
          { description: "Separation of application and network layers" }
        ]
      },
      {
        id: 16,
        title: "CAN Protocol Fundamentals",
        content: [
          { description: "Introduction to CAN (Controller Area Network)", type: "heading" },
          { description: "History and importance in automotive systems" },
          { description: "Event-driven communication model" },

          { description: "CAN Network Topology", type: "heading" },
          { description: "Bus structure" },
          { description: "Termination resistors" },

          { description: "CAN Communication Principles", type: "heading" },
          { description: "Broadcast communication" },
          { description: "Message-based (not node-based)" },

          { description: "CAN Speed and Variants", type: "heading" },
          { description: "Classical CAN" },
          { description: "CAN FD (overview)" },

          { description: "CAN Frames, Identifiers & Arbitration", type: "heading" },

          { description: "CAN Frame Types", type: "heading" },
          { description: "Data frame" },
          { description: "Remote frame" },
          { description: "Error frame" },
          { description: "Overload frame" },

          { description: "CAN Frame Structure", type: "heading" },
          { description: "Start of Frame (SOF)" },
          { description: "Identifier" },
          { description: "Control field" },
          { description: "Data field" },
          { description: "CRC" },
          { description: "ACK" },
          { description: "End of Frame (EOF)" },

          { description: "CAN Identifiers", type: "heading" },
          { description: "Standard (11-bit) ID" },
          { description: "Extended (29-bit) ID" },
          { description: "Priority concept using identifiers" },

          { description: "CAN Arbitration Mechanism", type: "heading" },
          { description: "CSMA/CR (Carrier Sense Multiple Access / Collision Resolution)" },
          { description: "Dominant vs recessive bits" },
          { description: "Non-destructive arbitration" },

          { description: "Error Handling in CAN", type: "heading" },
          { description: "Error detection mechanisms" },
          { description: "Error states (Error Active, Error Passive, Bus-Off)" }
        ]
      },
      {
        id: 17,
        title: "Introduction to AUTOSAR",
        content: [
          { description: "Need for AUTOSAR standardization", type: "heading" },
          { description: "Automotive Software Challenges (Pre-AUTOSAR)" },
          { description: "Vendor-dependent ECU software" },
          { description: "Poor reusability of code" },
          { description: "High integration and maintenance cost" },
          { description: "Tight coupling between hardware and software" },

          { description: "Growing Complexity in Vehicles", type: "heading" },
          { description: "Increase in number of ECUs" },
          { description: "Complex communication requirements" },
          { description: "Safety and regulatory compliance" },

          { description: "Benefits of Standardization", type: "heading" },
          { description: "Software reusability" },
          { description: "Hardware independence" },
          { description: "Scalability and maintainability" },
          { description: "Faster development cycles" },

          { description: "AUTOSAR Objectives", type: "heading" },
          { description: "Standardized software architecture" },
          { description: "Separation of application and hardware" },
          { description: "Support for safety-critical systems" }
        ]
      },
      {
        id: 18,
        title: "AUTOSAR History & Evolution",
        content: [
          { description: "Formation of AUTOSAR Consortium", type: "heading" },
          { description: "Founding members (OEMs and suppliers)" },
          { description: "Vision and mission" },

          { description: "Early AUTOSAR Development", type: "heading" },
          { description: "Initial focus on Classic Platform" },
          { description: "ECU-based software architecture" },

          { description: "Industry Adoption", type: "heading" },
          { description: "Adoption by major OEMs and Tier-1 suppliers" },
          { description: "Growth across automotive domains" },

          { description: "Evolution Drivers", type: "heading" },
          { description: "ADAS and autonomous driving" },
          { description: "High-performance computing needs" },
          { description: "Connectivity and over-the-air updates" }
        ]
      },
      {
        id: 19,
        title: "AUTOSAR Classic vs AUTOSAR Adaptive",
        content: [
          { description: "AUTOSAR Classic Platform", type: "heading" },
          { description: "Purpose and Design Philosophy" },
          { description: "Static configuration" },
          { description: "Real-time, safety-critical systems" },

          { description: "Key Characteristics", type: "heading" },
          { description: "ECU-based architecture" },
          { description: "Fixed memory allocation" },
          { description: "Strong real-time determinism" },

          { description: "Typical Use Cases", type: "heading" },
          { description: "Powertrain" },
          { description: "Body electronics" },
          { description: "Chassis systems" }
        ]
      },
      {
        id: 20,
        title: "AUTOSAR Classic vs AUTOSAR Adaptive",
        content: [
          { description: "AUTOSAR Adaptive Platform", type: "heading" },
          { description: "Purpose and Design Philosophy" },
          { description: "Dynamic, service-oriented architecture" },
          { description: "High-performance computing" },

          { description: "Key Characteristics", type: "heading" },
          { description: "POSIX-based OS (e.g., Linux/QNX)" },
          { description: "Dynamic applications and services" },
          { description: "Support for OTA updates" },

          { description: "Typical Use Cases", type: "heading" },
          { description: "ADAS" },
          { description: "Autonomous driving" },
          { description: "Infotainment and connectivity" }
        ]
      },
      {
        id: 21,
        title: "AUTOSAR Use Cases & Release Versions",
        content: [
          { description: "Powertrain Systems", type: "heading" },
          { description: "Engine control" },
          { description: "Transmission management" },

          { description: "Body & Comfort Systems", type: "heading" },
          { description: "Door modules" },
          { description: "Lighting systems" },
          { description: "Climate control" },

          { description: "Chassis Systems", type: "heading" },
          { description: "ABS" },
          { description: "ESC" },
          { description: "Steering systems" },

          { description: "ADAS & Autonomous Systems", type: "heading" },
          { description: "Sensor fusion" },
          { description: "Path planning" },
          { description: "Decision-making systems" },

          { description: "Software Reuse Across ECUs", type: "heading" },
          { description: "Platform reuse across vehicle models" },
          { description: "Multi-OEM development advantages" },

          { description: "AUTOSAR Release Versions Overview", type: "heading" },
          { description: "AUTOSAR Release Strategy" },
          { description: "Release naming convention" },
          { description: "Major vs minor releases" },

          { description: "Classic Platform Releases", type: "heading" },
          { description: "AUTOSAR 3.x overview" },
          { description: "AUTOSAR 4.x overview" },
          { description: "Improvements and new features" },

          { description: "Adaptive Platform Releases", type: "heading" },
          { description: "Initial adaptive releases" },
          { description: "Feature expansion in later versions" },

          { description: "Compatibility & Migration", type: "heading" },
          { description: "Backward compatibility" },
          { description: "Migration considerations for OEMs and suppliers" },

          { description: "Importance of Version Awareness", type: "heading" },
          { description: "Project-specific version selection" },
          { description: "Toolchain compatibility" }
        ]
      },
      {
        id: 22,
        title: "AUTOSAR Classic Platform Architecture",
        content: [
          { description: "Overview of AUTOSAR Classic Platform", type: "heading" },
          { description: "Purpose of AUTOSAR Classic Platform" },
          { description: "Standardized ECU software architecture" },
          { description: "Designed for real-time, safety-critical systems" },

          { description: "Key Characteristics", type: "heading" },
          { description: "Static configuration" },
          { description: "Deterministic execution" },
          { description: "ECU-based architecture" },

          { description: "Where Classic Platform is Used", type: "heading" },
          { description: "Powertrain" },
          { description: "Body electronics" },
          { description: "Chassis systems" },

          { description: "High-Level Architecture View", type: "heading" },
          { description: "Application Layer" },
          { description: "Runtime Environment (RTE)" },
          { description: "Basic Software (BSW)" },

          { description: "Layered Architecture Concept", type: "heading" },
          { description: "Understand separation of concerns in AUTOSAR." },

          { description: "Why Layered Architecture?", type: "heading" },
          { description: "Hardware abstraction" },
          { description: "Software reuse" },
          { description: "Independent development" },

          { description: "AUTOSAR Layers Overview", type: "heading" },
          { description: "Application Layer" },
          { description: "RTE" },
          { description: "BSW" },

          { description: "Interaction Between Layers", type: "heading" },
          { description: "Data flow and control flow" },
          { description: "Dependency rules" },

          { description: "Benefits of Layered Design", type: "heading" },
          { description: "Scalability" },
          { description: "Maintainability" },
          { description: "Portability" }
        ]
      },
      {
        id: 23,
        title: "Application Layer (Software Components – SWCs)",
        content: [
          { description: "What is an AUTOSAR Software Component (SWC)?", type: "heading" },
          { description: "Functional units of application logic" },

          { description: "Types of SWCs", type: "heading" },
          { description: "Application SWCs" },
          { description: "Sensor/Actuator SWCs" },
          { description: "Complex Device Drivers (CDD – intro)" },

          { description: "SWC Interfaces", type: "heading" },
          { description: "Sender-Receiver interfaces" },
          { description: "Client-Server interfaces" },
          { description: "Ports and Runnables" },
          { description: "Required vs provided ports" },
          { description: "Runnables as executable units" },

          { description: "SWC Independence", type: "heading" },
          { description: "Hardware-independent design" },
          { description: "Reusability across ECUs" },

          { description: "Runtime Environment (RTE)", type: "heading" },
          { description: "Purpose of RTE" },
          { description: "Middleware between Application and BSW" },

          { description: "Key Responsibilities of RTE", type: "heading" },
          { description: "Inter-SWC communication" },
          { description: "Communication with BSW services" },
          { description: "OS integration" },

          { description: "Types of Communication via RTE", type: "heading" },
          { description: "Intra-ECU communication" },
          { description: "Inter-ECU communication" },

          { description: "RTE Generation", type: "heading" },
          { description: "Generated from system description" },
          { description: "Tool-based configuration" },

          { description: "Benefits of RTE", type: "heading" },
          { description: "Location transparency" },
          { description: "Decoupling of components" },

          { description: "Basic Software (BSW) Overview", type: "heading" },
          { description: "What is Basic Software (BSW)?" },
          { description: "Standardized services for ECU operation" },

          { description: "Major BSW Layers", type: "heading" },
          { description: "Services Layer" },
          { description: "ECU Abstraction Layer" },
          { description: "Microcontroller Abstraction Layer (MCAL)" },

          { description: "Role of BSW", type: "heading" },
          { description: "Hardware access" },
          { description: "Communication services" },
          { description: "Memory and diagnostics services" },

          { description: "Static Configuration Concept", type: "heading" },
          { description: "BSW configured at design time" },
          { description: "Minimal runtime changes" },

          { description: "Services Layer", type: "heading" },
          { description: "System Services: Operating System (OS), ECU State Manager" },
          { description: "Communication Services: COM, PDU Router" },
          { description: "Memory Services: NVRAM Manager, Flash and EEPROM abstraction" },
          { description: "Diagnostic Services: Diagnostic Communication Manager (DCM), Diagnostic Event Manager (DEM)" },

          { description: "Microcontroller Abstraction Layer (MCAL)", type: "heading" },
          { description: "Purpose of MCAL" },
          { description: "Direct access to microcontroller peripherals" },

          { description: "MCAL Drivers Overview", type: "heading" },
          { description: "GPIO (Port, Dio)" },
          { description: "ADC" },
          { description: "PWM" },
          { description: "SPI, I2C" },
          { description: "CAN" },

          { description: "Vendor Dependency", type: "heading" },
          { description: "MCU-specific implementation" },
          { description: "Standard AUTOSAR APIs" },

          { description: "Safety & Performance Considerations", type: "heading" },
          { description: "Real-time constraints" },
          { description: "Hardware compliance" },

          { description: "Communication Flow in AUTOSAR Classic", type: "heading" },
          { description: "Data Flow Path : SWC → RTE → COM → PDU Router → CAN Interface → CAN Driver" },

          { description: "Inter-ECU Communication", type: "heading" },
          { description: "Signal transmission" },
          { description: "Message reception" },

          { description: "Timing & Scheduling Influence", type: "heading" },
          { description: "OS tasks" },
          { description: "Runnable execution timing" }
        ]
      },
      {
        id: 24,
        title: "AUTOSAR OS & Task Scheduling",
        content: [
          { description: "Introduction to AUTOSAR Operating System", type: "heading" },
          { description: "Understand the role of OS in AUTOSAR Classic systems" },
          { description: "What is an AUTOSAR OS?" },
          { description: "OSEK/VDX–based real-time operating system" },
          { description: "Designed for safety-critical automotive systems" },

          { description: "Role of OS in ECU Software", type: "heading" },
          { description: "Task scheduling" },
          { description: "Resource management" },
          { description: "Interrupt handling" },
          { description: "Timing control" },

          { description: "AUTOSAR OS vs General-Purpose OS", type: "heading" },
          { description: "Deterministic behavior" },
          { description: "Static configuration" },
          { description: "No dynamic task creation" },

          { description: "AUTOSAR OS Architecture Overview", type: "heading" },
          { description: "Core Components" },
          { description: "Tasks" },
          { description: "ISRs (Interrupt Service Routines)" },
          { description: "Resources" },
          { description: "Events" },
          { description: "Alarms & counters" },

          { description: "Single-Core vs Multi-Core OS (Overview)", type: "heading" },
          { description: "Multi-core ECU trends" },
          { description: "Basic multi-core scheduling concepts" },

          { description: "OS Configuration Concept", type: "heading" },
          { description: "Static configuration using tools" },
          { description: "Generated OS code" },

          { description: "Tasks in AUTOSAR OS", type: "heading" },
          { description: "What is a Task?" },
          { description: "Basic execution unit" },
          { description: "Invokes AUTOSAR runnables" },

          { description: "Types of Tasks", type: "heading" },
          { description: "Basic Task" },
          { description: "Extended Task" },

          { description: "Task States", type: "heading" },
          { description: "Suspended" },
          { description: "Ready" },
          { description: "Running" },
          { description: "Waiting" },

          { description: "Task Priorities", type: "heading" },
          { description: "Fixed-priority scheduling" },
          { description: "Priority assignment rules" },

          { description: "Scheduling Concepts", type: "heading" },
          { description: "Scheduling Policies" },
          { description: "Preemptive scheduling" },
          { description: "Non-preemptive scheduling" },
          { description: "Preemption Concept" },
          { description: "High-priority task interrupting low-priority task" },
          { description: "Cooperative vs Preemptive Tasks" },
          { description: "Configuration-based behavior" },

          { description: "Real-Time Determinism", type: "heading" },
          { description: "Meeting deadlines" },
          { description: "Predictable execution" },

          { description: "Interrupt Handling (ISRs)", type: "heading" },
          { description: "What is an Interrupt?" },
          { description: "Hardware-triggered events" },

          { description: "ISR Categories", type: "heading" },
          { description: "Category 1 ISR (Fast, non-OS aware)" },
          { description: "Category 2 ISR (OS-managed)" },

          { description: "ISR Priority & Nesting", type: "heading" },
          { description: "Priority levels" },
          { description: "Nested interrupts" },

          { description: "Interaction with Tasks", type: "heading" },
          { description: "Activating tasks from ISRs" },
          { description: "Setting events from ISRs" },

          { description: "Events & Extended Tasks", type: "heading" },
          { description: "Enable event-driven execution" },
          { description: "What are Events?" },
          { description: "Synchronization mechanism for tasks" },
          { description: "Event APIs" },
          { description: "SetEvent()" },
          { description: "ClearEvent()" },
          { description: "WaitEvent()" },
          { description: "Extended Task Behavior" },
          { description: "Blocking and waiting" },
          { description: "Event-based activation" },
          { description: "Use Cases: Communication reception, Sensor data availability" },

          { description: "Resources & Concurrency Control", type: "heading" },
          { description: "Prevent data corruption in multi-task systems" },
          { description: "Shared Resource Problem" },
          { description: "Race conditions" },
          { description: "Priority inversion" },

          { description: "AUTOSAR Resource Management", type: "heading" },
          { description: "Resources" },
          { description: "GetResource() / ReleaseResource()" },
          { description: "Priority Ceiling Protocol" },
          { description: "How priority inversion is avoided" },
          { description: "Best Practices" },
          { description: "Minimal resource holding time" },
          { description: "Avoid deadlocks" },

          { description: "Alarms, Counters & Scheduling Tables", type: "heading" },
          { description: "Handle time-triggered execution" },
          { description: "Counters: Software and hardware counters" },
          { description: "Alarms: Relative vs absolute alarms" },
          { description: "Periodic task activation" },

          { description: "Timing, Deadlines & OS Configuration", type: "heading" },
          { description: "Task Execution Time Analysis" },
          { description: "Worst-case execution time (WCET)" },
          { description: "Deadline Monitoring" },
          { description: "Importance in safety systems" },
          { description: "OS Configuration Parameters: Stack size, Task priority, Activation count" },
          { description: "Integration with RTE" },
          { description: "Runnable-task mapping" },
          { description: "Timing constraints" }
        ]
      },
      {
        id: 25,
        title: "AUTOSAR Communication Stack",
        content: [
          { description: "Introduction to AUTOSAR Communication", type: "heading" },
          { description: "Understand why AUTOSAR defines a layered communication architecture" },
          { description: "Purpose of AUTOSAR Communication Stack" },
          { description: "Standardized in-vehicle communication" },
          { description: "Hardware-independent data exchange" },
          { description: "Reusability across ECUs" },

          { description: "Communication Types", type: "heading" },
          { description: "Intra-ECU communication" },
          { description: "Inter-ECU communication" },
          { description: "Signal-based vs Message-based Communication" },
          { description: "Application-level signals" },
          { description: "Network messages" },

          { description: "Overview of Communication Stack Layers", type: "heading" },
          { description: "Layered Architecture" },
          { description: "Application Layer (RTE)" },
          { description: "Communication Services Layer" },
          { description: "ECU Abstraction Layer" },
          { description: "Microcontroller Abstraction Layer (MCAL)" },

          { description: "Data Flow Example", type: "heading" },
          { description: "Runnable → RTE → COM → PDU-R → CanIf → CAN Driver → CAN Bus" },

          { description: "Benefits of Layered Design", type: "heading" },
          { description: "Scalability" },
          { description: "Maintainability" },
          { description: "Hardware abstraction" },

          { description: "COM Module (Communication Services)", type: "heading" },
          { description: "Role of COM Module" },
          { description: "Signal and signal group management" },
          { description: "Packing/unpacking of signals into PDUs" },

          { description: "Key Concepts", type: "heading" },
          { description: "Signals" },
          { description: "Signal Groups" },
          { description: "I-PDU (Interaction PDU)" },

          { description: "COM Features", type: "heading" },
          { description: "Periodic & event-based transmission" },
          { description: "Signal update bits" },
          { description: "Timeout monitoring" },

          { description: "COM APIs (Overview)", type: "heading" },
          { description: "Com_SendSignal()" },
          { description: "Com_ReceiveSignal()" },

          { description: "PDU Router (PDU-R)", type: "heading" },
          { description: "Role of PDU-R" },
          { description: "Routing PDUs between COM and bus interfaces" },
          { description: "Gateway functionality" },

          { description: "Routing Types", type: "heading" },
          { description: "Upper layer to lower layer routing" },
          { description: "One-to-one and one-to-many routing" },

          { description: "PDU Types", type: "heading" },
          { description: "I-PDU" },
          { description: "N-PDU" },
          { description: "TP-PDU" },

          { description: "Use Cases", type: "heading" },
          { description: "CAN to CAN gateway" },
          { description: "CAN to LIN routing" },

          { description: "Transport Protocol (TP) Modules", type: "heading" },
          { description: "Need for Transport Protocol" },
          { description: "Payload size limitation of CAN frames" },
          { description: "Supported TP Modules: CanTp, LinTp, FrTp" },
          { description: "TP Features" },
          { description: "Segmentation & reassembly" },
          { description: "Flow control" },
          { description: "Error handling" },
          { description: "Typical Use Cases: Diagnostics (UDS), Firmware updates" },

          { description: "Network Interface Modules", type: "heading" },
          { description: "Interface between AUTOSAR stack and hardware drivers" },
          { description: "CAN Interface (CanIf): Abstracts CAN controller and driver, Manages Tx/Rx PDUs" },
          { description: "LIN Interface (LinIf): Handles LIN frame scheduling" },
          { description: "FlexRay Interface (FrIf): Time-triggered communication" },
          { description: "Ethernet Interface (EthIf): High-speed data exchange" },

          { description: "Network Management (NM)", type: "heading" },
          { description: "Control network sleep and wake-up behavior" },
          { description: "Purpose of Network Management: Power optimization, ECU coordination" },
          { description: "NM Types: CAN NM, LIN NM, FlexRay NM, Ethernet NM" },
          { description: "NM States: Bus sleep, Prepare bus sleep, Network mode" },
          { description: "Wake-up Sources: Network requests, ECU internal events" },

          { description: "Communication Error Handling & Monitoring", type: "heading" },
          { description: "Timeout Monitoring: Signal timeout, PDU timeout" },
          { description: "Error Detection: Frame loss, Bus-off conditions" },
          { description: "Interaction with DEM: Diagnostic trouble codes (DTCs)" },
          { description: "Recovery Strategies: Reinitialization, Network restart" },

          { description: "Communication Configuration & Tools", type: "heading" },
          { description: "Configuration Inputs: DBC, ARXML files" },
          { description: "Tool-Based Configuration: Signal mapping, PDU routing, Network parameters" },
          { description: "Generated Artifacts: Configuration C files, ECU Extracts" },
          { description: "Testing & Validation: CANoe / CANalyzer (conceptual), Simulation vs real ECU testing" }
        ]
      },
      {
        id: 26,
        title: "AUTOSAR Diagnostics (DCM, DEM) & Memory Stack",
        content: [
          { description: "Introduction to Automotive Diagnostics", type: "heading" },
          { description: "Purpose of Diagnostics" },
          { description: "Vehicle health monitoring" },
          { description: "Fault detection and reporting" },
          { description: "Compliance with OBD regulations" },

          { description: "Diagnostic Communication Basics", type: "heading" },
          { description: "Tester (Scan Tool) vs ECU" },
          { description: "Diagnostic sessions" },
          { description: "Diagnostic Protocols Overview" },
          { description: "UDS (ISO 14229)" },
          { description: "OBD-II basics (conceptual)" },

          { description: "Diagnostic Communication Manager (DCM)", type: "heading" },
          { description: "Role of DCM in AUTOSAR" },
          { description: "DCM in BSW Stack" },
          { description: "Interface between tester and application" },
          { description: "Works with COM, PDU-R, CanTp" },

          { description: "Responsibilities of DCM", type: "heading" },
          { description: "Request reception" },
          { description: "Service processing" },
          { description: "Response transmission" },

          { description: "Diagnostic Data Flow", type: "heading" },
          { description: "Tester → DCM → Application → DCM → Tester" },

          { description: "Diagnostic Sessions & Security", type: "heading" },
          { description: "Control access to ECU functions" },
          { description: "Diagnostic Sessions: Default session, Extended diagnostic session, Programming session" },
          { description: "Security Access: Seed & key mechanism, Security levels" },
          { description: "Session Timeouts: S3 server timing, Session switching rules" },

          { description: "DCM Configuration Concepts", type: "heading" },
          { description: "Learn how diagnostics is configured." },
          { description: "DCM Configuration Parameters: Service enabling/disabling, Session mapping, Security mapping" },

          { description: "Diagnostic Identifiers", type: "heading" },
          { description: "DID (Data Identifier)" },
          { description: "RID (Routine Identifier)" },
          { description: "Negative Response Codes (NRC)" },
          { description: "Common NRCs" },
          { description: "Error handling strategy" }
        ]
      },
      {
        id: 27,
        title: "AUTOSAR BSW Services",
        content: [
          { description: "Introduction to AUTOSAR BSW Services", type: "heading" },
          { description: "Why BSW Services Are Needed" },
          { description: "Role of BSW Services in AUTOSAR" },
          { description: "ECU lifecycle management" },
          { description: "System supervision and safety" },
          { description: "Mode coordination across software" },

          { description: "Typical System-Level Problems", type: "heading" },
          { description: "Improper startup/shutdown" },
          { description: "Uncontrolled task execution" },
          { description: "Missed deadlines and ECU hang" },

          { description: "Key BSW Service Modules Covered", type: "heading" },
          { description: "ECU State Manager (EcuM)" },
          { description: "Watchdog Manager (WdgM)" },
          { description: "Mode Management (BswM, ComM)" },

          { description: "ECU State Manager (EcuM)", type: "heading" },
          { description: "ECU Lifecycle Overview" },
          { description: "ECU Power States: Power ON, Sleep, Wakeup, Shutdown" },
          { description: "ECU Operating States: STARTUP, RUN, POST-RUN, SHUTDOWN, SLEEP" },

          { description: "ECU Startup Sequence", type: "heading" },
          { description: "Reset Handling: Cold start, Warm start" },
          { description: "Startup Phases: EcuM_Init(), Driver initialization, OS startup, BSW initialization, Application startup" },
          { description: "Startup Two-Phase Concept: Pre-OS initialization, Post-OS initialization" },

          { description: "Wakeup and Sleep Management", type: "heading" },
          { description: "Wakeup Sources: CAN bus, LIN bus, External pins" },
          { description: "Wakeup Validation: Wakeup detection, Wakeup confirmation" },
          { description: "Sleep Modes: Polling sleep, Halt sleep" },

          { description: "Shutdown Handling", type: "heading" },
          { description: "Shutdown Causes: Ignition OFF, Network sleep request, Internal ECU request" },
          { description: "Shutdown Target States: Reset, Sleep, Power OFF" },
          { description: "Safe Shutdown Sequence: Stop application, Store NvM data, Disable communication" },

          { description: "Watchdog Manager (WdgM)", type: "heading" },
          { description: "Watchdog Fundamentals" },
          { description: "Why Watchdog Is Required: Detect software deadlocks, Prevent ECU hang" },
          { description: "Hardware vs Software Watchdog: Hardware watchdog IC, Software supervision layer" },

          { description: "Watchdog Manager Architecture", type: "heading" },
          { description: "WdgM Role in AUTOSAR: Supervises tasks and runnables, Interfaces with Watchdog Driver" },
          { description: "Watchdog Modes: OFF, SLOW, FAST" },
          { description: "Watchdog Reaction Strategy: Local Reactions - Error notification, Mode change; Global Reactions - ECU reset, Fail-safe mode" },
          { description: "Integration with Safety Concepts (ASIL)" },

          { description: "Introduction to Mode Management", type: "heading" },
          { description: "What Are Modes? ECU modes, Communication modes, Application modes" },
          { description: "Why Mode Management Is Needed: Prevent inconsistent states, Centralized decision-making" },

          { description: "Basic Software Mode Manager (BswM)", type: "heading" },
          { description: "Role of BswM: Rule-based mode switching" },
          { description: "Inputs to BswM: EcuM states, ComM modes, WdgM status" },
          { description: "Outputs from BswM: Enable/disable services, Control communication" },

          { description: "Communication Manager (ComM)", type: "heading" },
          { description: "ComM Operating Modes: No Communication, Silent Communication, Full Communication" },
          { description: "Network Requests: Application requests, Release requests" },
          { description: "Interaction with NM & BswM" },

          { description: "Mode Flow Example", type: "heading" },
          { description: "Ignition ON: EcuM → RUN, ComM → Full Communication, WdgM → FAST mode" },
          { description: "Ignition OFF: ComM → No Communication, NvM write, EcuM → Shutdown" }
        ]
      },
      {
        id: 28,
        title: "AUTOSAR Configuration Tools",
        content: [
          { description: "Introduction to AUTOSAR Tooling", type: "heading" },
          { description: "Why AUTOSAR Configuration Tools Are Needed" },
          { description: "Purpose of ARXML: Configuration description, Interface definitions" },

          { description: "Types of ARXML Files", type: "heading" },
          { description: "System description" },
          { description: "ECU extract" },
          { description: "BSW configuration" },
          { description: "SWC description" },

          { description: "Key ARXML Elements", type: "heading" },
          { description: "Software Components" },
          { description: "Ports and Interfaces" },
          { description: "Runnables and events" },

          { description: "Vector DaVinci Tool Chain", type: "heading" },
          { description: "Vector DaVinci Overview" },

          { description: "DaVinci Developer", type: "heading" },
          { description: "SWC modeling" },
          { description: "RTE generation" },

          { description: "DaVinci Configurator", type: "heading" },
          { description: "BSW configuration" },
          { description: "ECU-specific setup" },

          { description: "DaVinci Network Designer (conceptual)", type: "heading" },
          { description: "Communication configuration" }
        ]
      },
    ]
  },
      {
        name: "Embedded C / C++ Programming",
        slug: "c-and-cpp-programming",
        icon:'fa-solid fa-c',
        description:"Build a strong foundation in programming with our C / C++ course. Learn core concepts like data types, pointers, memory management, object-oriented programming, and algorithm design. Gain hands-on experience writing efficient and robust code, developing console and desktop applications, and solving real-world problems. This course equips you with the essential programming skills needed to excel in software development and competitive coding.",
        mode: "Online",
        duration:"3 Months",
        logo:'11.png',
        modules: [
          {
  "id": 1,
  "title": "Programming & Embedded C Fundamentals",
  "content": [
    { "description": "Embedded Systems", "type": "heading" },
    { "description": "What is an Embedded System?" },
    { "description": "Definition and real-world examples" },
    { "description": "Differences between general-purpose and embedded systems" },

    { "description": "Embedded Systems in Automotive Domain", "type": "heading" },
    { "description": "ECUs (Engine, Body, ADAS, Infotainment)" },
    { "description": "Role of software in modern vehicles" },

    { "description": "Automotive Software Overview", "type": "heading" },
    { "description": "Bare-metal vs RTOS-based systems" },
    { "description": "Introduction to AUTOSAR software stack (high-level view)" },

    { "description": "Development Environment Basics", "type": "heading" },
    { "description": "Cross-compiler concept" },
    { "description": "IDE overview (Eclipse, VS Code, etc.)" },

    { "description": "Week 1 Assignments", "type": "heading" },
    { "description": "Assignment 1: Write a short note on what an embedded system is and provide 3 real-world examples." },
    { "description": "Assignment 2: Create a comparison table showing at least 5 differences between general-purpose and embedded systems." },
    { "description": "Assignment 3: List at least 4 different types of ECUs in modern vehicles and explain the role of software in each." },
    { "description": "Assignment 4: Install an IDE (Eclipse or VS Code) for embedded C development and write a short note on your experience setting it up." }
  ]
},
{
  "id": 2,
  "title": "C Language Structure & Compilation Process",
  "content": [
    { "description": "Structure of a C Program", "type": "heading" },
    { "description": "Header files" },
    { "description": "main() function" },
    { "description": "Preprocessor directives" },

    { "description": "C Compilation Flow", "type": "heading" },
    { "description": "Preprocessing" },
    { "description": "Compilation" },
    { "description": "Assembly" },
    { "description": "Linking" },

    { "description": "Toolchain Overview", "type": "heading" },
    { "description": "Compiler, linker, loader" },
    { "description": "Embedded vs desktop compilation" },

    { "description": "Common Compilation Errors & Warnings", "type": "heading" },
    { "description": "Syntax vs semantic errors" },
    { "description": "Importance of warnings in safety-critical code" }
  ]
},
{
  "id": 3,
  "title": "Data Types, Operators & Control Statements",
  "content": [
    { "description": "Basic Data Types", "type": "heading" },
    { "description": "int, char, float, double" },
    { "description": "Signed vs unsigned" },
    { "description": "Size of data types in embedded systems" },

    { "description": "Derived & User-Defined Types (intro)", "type": "heading" },
    { "description": "Arrays (basic idea)" },
    { "description": "Structures (basic idea)" },

    { "description": "Operators", "type": "heading" },
    { "description": "Arithmetic, relational, logical" },
    { "description": "Assignment and conditional operators" },

    { "description": "Control Statements", "type": "heading" },
    { "description": "if-else if-else ladder" },
    { "description": "for loop" },
    { "description": "while loop" },
    { "description": "do-while loop" },
    { "description": "switch cases" },
    { "description": "Best practices for deterministic loops" }
  ]
},
{
  "id": 4,
  "title": "Functions, Recursion & Modular Programming",
  "content": [
    { "description": "Function Basics", "type": "heading" },
    { "description": "Function declaration, definition, calling" },
    { "description": "Parameter passing (by value)" },
    { "description": "Return Types and Scope" },
    { "description": "Local vs global variables" },
    { "description": "static variables in functions" },

    { "description": "Modular Programming", "type": "heading" },
    { "description": "Header (.h) and source (.c) files" },
    { "description": "Code separation and reuse" },

    { "description": "Recursion", "type": "heading" },
    { "description": "Concept and examples" },
    { "description": "Why recursion is generally avoided in embedded systems" },

    { "description": "Problem-solving on Functions", "type": "heading" },
    { "description": "Exercise on functions" }
  ]
},
{
  "id": 5,
  "title": "Memory-level Programming in AUTOSAR",
  "content": [
    { "description": "Arrays", "type": "heading" },
    { "description": "One-dimensional and multi-dimensional arrays" },
    { "description": "Passing arrays to functions" },

    { "description": "Pointers", "type": "heading" },
    { "description": "Pointer basics and syntax" },
    { "description": "Pointer arithmetic" },
    { "description": "Pointers vs arrays" },

    { "description": "Structures", "type": "heading" },
    { "description": "Defining and accessing structures" },
    { "description": "Nested structures" },
    { "description": "Structures in hardware abstraction" },

    { "description": "Unions", "type": "heading" },
    { "description": "Difference between structure and union" },
    { "description": "Memory optimization use cases" },

    { "description": "Enums", "type": "heading" },
    { "description": "Enumerations for readable and safe code" },
    { "description": "Use in state machines" },

    { "description": "Exercise on memory-level programming", "type": "heading" }
  ]
},
{
  "id": 6,
  "title": "Understanding Memory Usage for Reliable Embedded Applications",
  "content": [
    { "description": "Embedded Memory Architecture", "type": "heading" },
    { "description": "Flash" },
    { "description": "RAM" },
    { "description": "EEPROM overview" },

    { "description": "Stack Memory", "type": "heading" },
    { "description": "Function calls and local variables" },
    { "description": "Stack overflow risks" },

    { "description": "Heap Memory", "type": "heading" },
    { "description": "Dynamic memory allocation (malloc, free)" },
    { "description": "Why dynamic memory is avoided in AUTOSAR" },

    { "description": "Static Memory", "type": "heading" },
    { "description": "Global and static variables" },
    { "description": "Lifetime and memory placement" },

    { "description": "Memory Optimization Techniques", "type": "heading" },
    { "description": "Reducing RAM usage" },
    { "description": "Avoiding fragmentation" }
  ]
},
{
  "id": 7,
  "title": "Bitwise Operations & Register Access",
  "content": [
    { "description": "Bitwise Operators", "type": "heading" },
    { "description": "AND, OR, XOR, NOT" },
    { "description": "Left and right shift operations" },

    { "description": "Bit Masking Techniques", "type": "heading" },
    { "description": "Set, clear, toggle bits" },
    { "description": "Reading specific bits" },

    { "description": "Hardware Register Access", "type": "heading" },
    { "description": "Memory-mapped I/O concept" },
    { "description": "Volatile keyword usage" },

    { "description": "Practical Embedded Examples", "type": "heading" },
    { "description": "LED control simulation" },
    { "description": "Register configuration patterns" },

    { "description": "Exercise on operators", "type": "heading" },
    
  ]
},
{
  "id": 8,
  "title": "MISRA C Overview & Safe Coding Practices",
  "content": [
    { "description": "Why MISRA C?", "type": "heading" },
    { "description": "Safety, reliability, and maintainability" },
    { "description": "Automotive compliance requirements" },

    { "description": "MISRA C Guidelines Overview", "type": "heading" },
    { "description": "Mandatory vs advisory rules" },
    { "description": "Common rule violations" },

    { "description": "Safe Coding Practices", "type": "heading" },
    { "description": "Avoiding undefined behavior" },
    { "description": "Type safety and explicit casting" },

    { "description": "Code Quality Techniques", "type": "heading" },
    { "description": "Defensive programming" },
    { "description": "Code reviews and static analysis tools" }
  ]
},
{
  "id": 9,
  "title": "Pointers – Advanced & Dangerous Areas",
  "content": [
    { "description": "Pointer Basics (Advanced)", "type": "heading" },
    { "description": "Pointer to pointer" },
    { "description": "Function pointers" },
    { "description": "Array of function pointers (state machines)" },
    { "description": "const with pointers (all combinations)" },
    { "description": "Pointer arithmetic" },
    { "description": "restrict keyword" },

    { "description": "Dangerous Areas of Pointers", "type": "heading" },
    { "description": "Dangling pointers" },
    { "description": "Memory corruption patterns" }
  ]
},
{
  "id": 10,
  "title": "Advanced Embedded Programming: Bit Manipulation, RTOS & Embedded C++",
  "content": [
    { "description": "Bit Manipulation & Register Programming", "type": "heading" },
    { "description": "Bit masking & shifting" },
    { "description": "Set / clear / toggle bits" },
    { "description": "Bit-fields (pros & cons)" },
    { "description": "Atomic bit operations" },
    { "description": "Macros vs inline functions" },
    { "description": "Read-modify-write problems" },

    { "description": "Preprocessor Mastery", "type": "heading" },
    { "description": "Multi-line macros" },
    { "description": "Token pasting (##)" },
    { "description": "Stringification (#)" },
    { "description": "Conditional compilation" },
    { "description": "Compile-time configuration" },
    { "description": "Macro pitfalls" },

    { "description": "Interrupts & ISRs", "type": "heading" },
    { "description": "Interrupt latency" },
    { "description": "Nesting & priorities" },
    { "description": "ISR vs task context" },
    { "description": "Reentrancy" },
    { "description": "Critical sections" },
    { "description": "Disabling interrupts safely" },
    { "description": "ISR communication patterns" },

    { "description": "RTOS Internals", "type": "heading" },
    { "description": "Context switching" },
    { "description": "Task states" },
    { "description": "Preemptive vs cooperative scheduling" },
    { "description": "Priority inversion & inheritance" },
    { "description": "Queues vs Semaphores vs Mutex" },
    { "description": "Event groups" },
    { "description": "Software timers" },
    { "description": "Memory allocation schemes" },

    { "description": "Embedded Debugging & Optimization", "type": "heading" },
    { "description": "JTAG / SWD debugging" },
    { "description": "HardFault analysis" },
    { "description": "Stack overflow detection" },
    { "description": "Watchdogs" },
    { "description": "Performance profiling" },
    { "description": "Code size optimization" },
    { "description": "Power optimization techniques" },

    { "description": "Embedded C++ Fundamentals", "type": "heading" },
    { "description": "C++ vs C in embedded" },
    { "description": "Zero-cost abstractions" },
    { "description": "Compile-time vs run-time" },
    { "description": "RAII in embedded" },
    { "description": "constexpr" },
    { "description": "static_assert" },

    { "description": "OOP for Embedded Systems", "type": "heading" },
    { "description": "Encapsulation for drivers" },
    { "description": "Inheritance (when to avoid)" },
    { "description": "Polymorphism cost" },
    { "description": "Virtual functions & vtables" },
    { "description": "Abstract interfaces for HAL" },

    { "description": "Templates & Metaprogramming (Advanced)", "type": "heading" },
    { "description": "Function templates" },
    { "description": "Class templates" },
    { "description": "Template specialization" },
    { "description": "Type traits" },
    { "description": "Compile-time calculations" },

    { "description": "Memory Management in Embedded C++", "type": "heading" },
    { "description": "Placement new" },
    { "description": "Custom allocators" },
    { "description": "Avoiding dynamic allocation" },
    { "description": "Object lifetime management" },
    { "description": "Fragmentation risks" },

    { "description": "Embedded C++ in AUTOSAR / Large Systems", "type": "heading" },
    { "description": "BSW & MCAL abstraction" },
    { "description": "C++ in Adaptive AUTOSAR" },
    { "description": "Interface-based design" },
    { "description": "Code generation awareness" },
    { "description": "Integration with C modules" }
  ]
},



        ]
      }, 

      {
        "name": "AWS DevOps",
        "slug": "aws-devops",
        "icon": "fa-brands fa-aws",

        "mode": "Online & Offline & Hybrid",
        "duration": "6 Months",
        "logo": "awsdev.png",

        "description":
        "This AWS DevOps course provides end-to-end training on cloud infrastructure, CI/CD pipelines, automation, containerization, monitoring, and security using AWS and modern DevOps tools. The course is designed with real-time projects to make you job-ready as a DevOps Engineer or Cloud Engineer.",

        "modules": [
          {
            "id": 1,
            "title": "Linux & Networking Fundamentals",
            "content": [
              { "description": "Introduction to Linux", "type": "heading" },
              { "description": "Linux Architecture & Distributions" },
              { "description": "File System & Directory Structure" },
              { "description": "Basic Linux Commands" },

              { "description": "User & Permission Management", "type": "heading" },
              { "description": "Users, Groups & Permissions" },
              { "description": "Process & Service Management" },

              { "description": "Networking Basics", "type": "heading" },
              { "description": "IP Addressing & Subnetting" },
              { "description": "Ports, Protocols & Firewalls" }
            ]
          },

          {
            "id": 2,
            "title": "AWS Cloud Fundamentals",
            "content": [
              { "description": "Introduction to Cloud Computing", "type": "heading" },
              { "description": "Cloud Models (IaaS, PaaS, SaaS)" },
              { "description": "AWS Global Infrastructure" },

              { "description": "Core AWS Services", "type": "heading" },
              { "description": "EC2, S3, IAM" },
              { "description": "VPC, Subnets & Security Groups" },

              { "description": "AWS Billing & Pricing", "type": "heading" },
              { "description": "Cost Management & Free Tier" }
            ]
          },

          {
            "id": 3,
            "title": "Version Control & CI/CD",
            "content": [
              { "description": "Version Control with Git", "type": "heading" },
              { "description": "Git Workflow & Branching" },
              { "description": "GitHub Repositories" },

              { "description": "CI/CD Concepts", "type": "heading" },
              { "description": "Continuous Integration & Deployment" },

              { "description": "CI/CD Tools", "type": "heading" },
              { "description": "Jenkins Pipeline Setup" },
              { "description": "GitHub Actions Basics" },

              { "description": "Project: Automated CI/CD Pipeline" }
            ]
          },

          {
            "id": 4,
            "title": "Configuration Management & Automation",
            "content": [
              { "description": "Automation Concepts", "type": "heading" },
              { "description": "Why Automation in DevOps?" },

              { "description": "Ansible", "type": "heading" },
              { "description": "Ansible Architecture" },
              { "description": "Playbooks & Roles" },
              { "description": "Inventory Management" },

              { "description": "Project: Server Configuration Automation" }
            ]
          },

          {
            "id": 5,
            "title": "Containerization with Docker",
            "content": [
              { "description": "Docker Fundamentals", "type": "heading" },
              { "description": "What is Docker & Containers?" },
              { "description": "Docker Architecture" },

              { "description": "Docker Components", "type": "heading" },
              { "description": "Images & Containers" },
              { "description": "Dockerfile & Volumes" },

              { "description": "Docker Networking", "type": "heading" },
              { "description": "Bridge & Custom Networks" },

              { "description": "Project: Dockerized Application" }
            ]
          },

          {
            "id": 6,
            "title": "Container Orchestration with Kubernetes",
            "content": [
              { "description": "Kubernetes Basics", "type": "heading" },
              { "description": "K8s Architecture & Components" },
              { "description": "Pods, Nodes & Clusters" },

              { "description": "Kubernetes Objects", "type": "heading" },
              { "description": "Deployments & Services" },
              { "description": "ConfigMaps & Secrets" },

              { "description": "Kubernetes on AWS", "type": "heading" },
              { "description": "EKS Overview" },

              { "description": "Project: Kubernetes Deployment on AWS" }
            ]
          },

          {
            "id": 7,
            "title": "Infrastructure as Code (IaC)",
            "content": [
              { "description": "IaC Concepts", "type": "heading" },
              { "description": "Benefits of Infrastructure as Code" },

              { "description": "Terraform", "type": "heading" },
              { "description": "Terraform Architecture" },
              { "description": "Providers & Resources" },
              { "description": "State Management" },

              { "description": "Project: AWS Infrastructure with Terraform" }
            ]
          },

          {
            "id": 8,
            "title": "Monitoring, Logging & Security",
            "content": [
              { "description": "Monitoring Tools", "type": "heading" },
              { "description": "AWS CloudWatch" },
              { "description": "Prometheus & Grafana Basics" },

              { "description": "Logging", "type": "heading" },
              { "description": "Centralized Logging Concepts" },

              { "description": "Security & Best Practices", "type": "heading" },
              { "description": "IAM Roles & Policies" },
              { "description": "Secrets Management" }
            ]
          },

          {
            "id": 9,
            "title": "Capstone Projects & Career Prep",
            "content": [
              { "description": "Project 1: CI/CD Pipeline on AWS" },
              { "description": "Project 2: Docker + Kubernetes Deployment" },
              { "description": "Project 3: Terraform-Based AWS Infrastructure" },
              { "description": "Resume, Interview & DevOps Case Studies" }
            ]
          }
        ]
      },
      

      {
        name: "Diploma in MEAN Stack",
        slug: "diploma-in-mean-stack",
        icon:'fa-brands fa-node',
        mode: "Online & Offline & Hybrid",
        duration:"2.5 Months",
        logo:'rsz_1mean_.png',
        description:'Master the MEAN stack – MongoDB, Express.js, Angular, and Node.js – with our intensive diploma course. Gain hands-on experience building dynamic web applications and APIs using this popular and versatile technology stack. Whether you’re a web developer looking to expand your skill set or a newcomer to programming, our MEAN stack course is the perfect choice.',
        modules: [
          {
            id: 1,
            title: "1: Introduction of MEAN Stack",
            content : [
              {description: "Introduction to MEAN"},
              {description: "Defining MEAN"},
              {description: "Studying the Architecture of MEAN"},
              {description: "Scope of MEAN"},
              {description: "Benefits of using MEAN"},
              {description: "Applications of MEAN"},
              {description: "The four building components"},
              {description: "MVC Architecture for Web Application"},
              {description: "An Insight into MongoDB"},
              {description: "Difference between SQL vs NoSQL"},
              {description: "An Insight into Angular"},
              {description: "An Insight into Node.Js"},
              {description: "An Insight into Express"},
              {description: "Collaboration of the Four technologies"}
            ]
          },
          {
            id: 2,
            title: "2: Understanding MongoDB and NoSQL",
            content : [
              {description: "Scope of NoSQL"},
              {description: "MongoDB: Overview, Structure, and Application"},
              {description: "Commands: Shell and Native"},
              {description: "MongoDB and its connection"},
              {description: "Data Types in MongoDB"},
              {description: "Planning Data Model"},
              {description: "Creating MongoDB Environment"},
              {description: "Creating Users with Access rights"},
              {description: "Creating and modifying Database"},
              {description: "Saving Data and Database Queries"},
              {description: "Finding Documents"},
              {description: "Updating Documents"},
              {description: "Replication"},
              {description: "Clustering of MongoDB Servers"},
              {description: "Indexing"}
            ]
          },
          {
            id: 3,
            title: "3: Express Middleware",
            content : [
              {description: "What is Middleware"},
              {description: "Query Middleware"},
              {description: "How to serve Static Files"},
              {description: "POST Body Data and Cookies"},
              {description: "How to implement Sessions"},
              {description: "Basic HTTP Authentication"},
              {description: "Session Authentication"},
              {description: "Facebook access token authentication"},
              {description: "Gmail access token authentication"},
              {description: "Twitter access token authentication"}
            ]
          },
          {
            id: 4,
            title: "4: Mongoose, Schema and Validation",
            content : [
              {description: "What is Mongoose?"},
              {description: "How to connect to MongoDB using Mongoose"},
              {description: "What is a Schema"},
              {description: "How to compile a Model"},
              {description: "Understanding Objects: Query and Document"},
              {description: "Finding, Adding, Updating, Removing, and Aggregating Documents by using Mongoose"},
              {description: "How to use Validation Framework"},
              {description: "Interview Questions and test"}
            ]
          },
          {
            id: 5,
            title: "5: Angular, MongoDB, and Node.js",
            content : [
              {description: "Overview of Angular"},
              {description: "Application of Angular"},
              {description: "Developing Web Page with Angular"},
              {description: "First Program Angular"},
              {description: "Angular CLI"},
              {description: "Angular Modules: Set-Up and Architecture"},
              {description: "Component Using CLI"},
              {description: "Modules and Dependency Injection"},
              {description: "How to Integrate Angular with Bootstrap and Material-UI"},
              {description: "Adding Angular to Node.js Environment"},
              {description: "Broadcasting and Emitting Events"},
              {description: "Templates and views, Expressions and Pipes"},
              {description: "Services creation using CLI"},
              {description: "Routing creation using CLI"},
              {description: "Using Built-in Directives"},
              {description: "Directives creation using CLI"},
              {description: "Creating your own Directives to Extend HTML"},
              {description: "Creating Nested Routes and Application"},
              {description: "AngularJS Services: Built-in and Custom Services"},
              {description: "Http Module of NodeJS"},
              {description: "FS Module of NodeJS"},
              {description: "Buffers, Streams, and Events"},
              {description: "CRUD commands in MongoDB"},
              {description: "REST/HTTP requests in a REST API"},
              {description: "Interview Questions and test"}
            ]
          },
          {
            id: 6,
            title: "6: Getting Started with MongoDB and Node.js",
            content : [
              {description: "How to add MongoDB Driver to Node.js"},
              {description: "How to connect to MongoDB from Node.js"},
              {description: "Objects used in the MongoDB Node.js Driver"},
              {description: "How to Access and Manipulate Databases and Collections"},
              {description: "How to Manipulate MongoDB Documents from Node.js"},
              {description: "Database Change Options and Database Update Operators"},
              {description: "Adding Documents to a Collection"},
              {description: "Getting Documents from a Collection"},
              {description: "Updating Documents in a Collection"},
              {description: "Modifying and Saving Documents in a Collection"},
              {description: "Deleting Documents from a Collection"},
              {description: "What is a Data Set"},
              {description: "Query Objects"},
              {description: "Specific Sets of Documents"},
              {description: "Counting Documents"},
              {description: "Limiting, Sorting, and Grouping Result sets"},
              {description: "Mapreduce and Results"},
              {description: "Interview Questions and test"}
            ]
          },
          {
            id: 7,
            title: "7: Collaboration of All topics together and Project and implementation",
            content : [
              {description: "Create 2 Projects"},
              {description: "Understand GitHub"},
              {description: "Uploading Source code to GItHub"},
              {description: "Upload to Heroku or any server and make application live"},
              {description: "Interview Questions and test"}
            ]
          }



        ]
      },
      {
        name: "Full Stack Java Development",
        slug: "diploma-in-java",
        icon:'fa-brands fa-java',
        mode: "Online & Offline & Hybrid",
        duration:"3 Months",
        logo:'3.png',
        description:"Unlock your programming potential with our Diploma in Java course. Learn the fundamentals of Java programming, object-oriented concepts, and application development. Gain hands-on experience building desktop and web applications, understanding Java frameworks, and mastering best coding practices. This course equips you with the skills needed to excel as a Java developer and create robust, scalable software solutions.",
        modules: [
          {
            "id": 1,
            "title": "Java Fundamentals",
            "content": [
              {"description": "Classes and Objects"},
              {"description": "Operators, Control Statements & loops"},
              {"description": "Arrays"},
              {"description": "Methods"},
              {"description": "Blocks"},
              {"description": "Constructor"},
              {"description": "Static Member"}
            ]
          },
          {
            "id": 2,
            "title": "Object-Oriented Programming",
            "content": [
              {"description": "Inheritance"},
              {"description": "Polymorphism (Overloading and Overriding)"},
              {"description": "Abstraction (Abstract Class and Interface)"},
              {"description": "Encapsulation"}
            ]
          },
          {
            "id": 3,
            "title": "Packages",
            "content": [
              {"description": "Why packages"},
              {"description": "Understanding Classpath"},
              {"description": "Access modifiers & their Scope"}
            ]
          },
          {
            "id": 4,
            "title": "Exception Handling",
            "content": [
              {"description": "Importance of Exception Handling"},
              {"description": "Types of Exception Handling"},
              {"description": "Exception Handling Using try and catch"},
              {"description": "Exception Handling Using try, catch and finally"},
              {"description": "Exception Handling Using throws"},
              {"description": "Writing User defined Exceptions using throw"},
              {"description": "User Defined Exception Handling using try, catch and throws"}
            ]
          },
          {
            "id": 5,
            "title": "String Manipulation",
            "content": [
              {"description": "String class and their methods"},
              {"description": "String Buffer class and their methods"},
              {"description": "StringBuilder class and their methods"},
              {"description": "StringTokenizer class and their methods"}
            ]
          },
          {
            "id": 6,
            "title": "Wrapper Class",
            "content": [
              {"description": "Why wrapper class"},
              {"description": "AutoBoxing and AutoUnBoxing"},
              {"description": "parseYYY() methods"}
            ]
          },
          {
            "id": 7,
            "title": "Regular Expression",
            "content": [
              {"description": "Why regular expression"},
              {"description": "Pattern class"},
              {"description": "Matcher class"},
              {"description": "Patterns"}
            ]
          },
          {
            "id": 8,
            "title": "File IO operations",
            "content": [
              {"description": "File Handling"},
              {"description": "Character Oriented Stream"},
              {"description": "Byte Oriented Streams"},
              {"description": "Readers and Writers"},
              {"description": "Serialization"},
              {"description": "Reading and writing data from different file formats"}
            ]
          },
          {
            "id": 9,
            "title": "Multithreaded Programming",
            "content": [
              {"description": "Introduction Multi-Threading"},
              {"description": "Understanding Threads & its States"},
              {"description": "Life Cycle of thread"},
              {"description": "Thread class & Runnable Interface"},
              {"description": "Thread Priorities"},
              {"description": "Synchronization"},
              {"description": "Inter thread Communication"},
              {"description": "Preventing Deadlocks"},
              {"description": "sleep() vs join() vs yield()"}
            ]
          },
          {
            "id": 10,
            "title": "Java Util Package / Collections Framework",
            "content": [
              {"description": "Collection & Iterator Interface"},
              {"description": "Comparator vs Comparable"},
              {"description": "Enumeration"},
              {"description": "Cursor"},
              {"description": "Generics"},
              {"description": "List and their classes"},
              {"description": "Set and their classes"},
              {"description": "Map and their classes"},
              {"description": "Properties"},
              {"description": "HashTable"},
              {"description": "Dictionary"}
            ]
          },
          {
            "id": 11,
            "title": "Inner Classes",
            "content": [
              {"description": "Why Inner Class"},
              {"description": "Normal Inner class"},
              {"description": "Method local Inner Class"},
              {"description": "Anonymous Classes"}
            ]
          },
          {
            "id": 12,
            "title": "Abstract Window Toolkit and Swing Programming",
            "content": [
              {"description": "Graphics"},
              {"description": "Color and Font"},
              {"description": "AWT Components/Controls"},
              {"description": "Event Handling & Layouts"},
              {"description": "Introduction Swing & MVC Architecture"},
              {"description": "Swing Hierarchy"},
              {"description": "Atomic Components e.g. JButton, JList and more"},
              {"description": "Intermediate Container e.g. JPanel, JSplitPane and more"},
              {"description": "Top-Level Container e.g. JFrame and JApplet"}
            ]
          },
          {
            "id": 13,
            "title": "Java Database Connectivity (JDBC)",
            "content": [
              {"description": "Overview of RDBMS"},
              {"description": "Introduction JDBC"},
              {"description": "JDBC Architecture"},
              {"description": "Types of JDBC Drivers"},
              {"description": "Establishing a JDBC Connection"},
              {"description": "Using Statement"},
              {"description": "Using PreparedStatement"},
              {"description": "Using CallableStatement"},
              {"description": "Creating Procedures"},
              {"description": "Creating Joins"},
              {"description": "ResultSet"}
            ]
          },
          {
            "id": 14,
            "title": "Servlets",
            "content": [
              {"description": "Servlet as J2EE Web Component"},
              {"description": "Servlet Fundamentals / API"},
              {"description": "What is a Web-Container"},
              {"description": "MVC Architecture"},
              {"description": "Servlet Life Cycle / Architecture"},
              {"description": "HTTP GET and POST Request Methods"},
              {"description": "Processing Html Forms"},
              {"description": "Content Types and MIME"},
              {"description": "Servlet vs GenericServlet vs HttpServlet"},
              {"description": "Session Maintains"}
            ]
          },
          {
            "id": 15,
            "title": "Java Server Pages (JSP)",
            "content": [
              {"description": "JSP Architecture"},
              {"description": "JSP Standard / Implicit Objects"},
              {"description": "JSP Page Implementation Class"},
              {"description": "JSP Basics & Syntax"},
              {"description": "JSP Directive Tags"},
              {"description": "Page Directive"},
              {"description": "Include Directive"},
              {"description": "Taglib Directive"},
              {"description": "JSP Action Tags"}
            ]
          },
          {
            "id": 16,
            "title": "Spring Basics",
            "content": [
              {"description": "What is Spring Framework"},
              {"description": "Inversion of Control"},
              {"description": "Dependency Injection"},
              {"description": "Bean Factory"},
              {"description": "Developing First Spring Application"},
              {"description": "Spring Container"},
              {"description": "Built-in Bean Factories"},
              {"description": "Application Context"},
              {"description": "Wiring Beans"},
              {"description": "Bean Lifecycle in Container"},
              {"description": "Spring Events"}
            ]
          },
          {
            "id": 17,
            "title": "Spring AOP",
            "content": [
              {"description": "Introduction AOP"},
              {"description": "Role of AOP in Spring"},
              {"description": "AOP Advice"},
              {"description": "AOP Pointcuts"},
              {"description": "ProxyFactoryBean"}
            ]
          },
          {
            "id": 18,
            "title": "Spring Data Access",
            "content": [
              {"description": "JDBC Abstraction Layer"},
              {"description": "Data Access Exceptions"},
              {"description": "DASupport"},
              {"description": "What is O-R Mapping"},
              {"description": "O-R Mapping support in Spring"}
            ]
          },
          {
            "id": 19,
            "title": "Spring Web MVC Framework",
            "content": [
              {"description": "Web MVC Architecture"},
              {"description": "Role of DispatcherServlet"},
              {"description": "Controller"},
              {"description": "Handler"},
              {"description": "View Resolving"},
              {"description": "Data Binding"},
              {"description": "File Upload Support"}
            ]
          },
          {
            "id": 20,
            "title": "Introduction Hibernate",
            "content": [
              {"description": "Drawbacks of JDBC"},
              {"description": "Plain Old Java Object (POJO)"},
              {"description": "What is O-R Mapping"},
              {"description": "Hibernate Configuration"},
              {"description": "Required JAR Files"},
              {"description": "Hibernate configuration File"},
              {"description": "Hibernate properties File"},
              {"description": "Hibernate XML File"},
              {"description": "SQL Dialects"}
            ]
          },
          {
            "id": 21,
            "title": "Hibernate Concepts",
            "content": [
              {"description": "Id and Primary Key"},
              {"description": "Id Generation Methods"},
              {"description": "Session Factory"},
              {"description": "Session"},
              {"description": "Transaction"}
            ]
          },
          {
            "id": 22,
            "title": "Developing CRUD Application",
            "content": [
              {"description": "Hibernate O-R Mapping"},
              {"description": "Mapping Declarations"},
              {"description": "Modeling Composition with Relationship"},
              {"description": "Modeling Composition with Components"},
              {"description": "One-to-One Association"},
              {"description": "One-to-Many Association"},
              {"description": "Many-to-Many Association"}
            ]
          },
          {
            "id": 23,
            "title": "Hibernate Query Language",
            "content": [
              {"description": "Select clause"},
              {"description": "From clause"},
              {"description": "Where clause"},
              {"description": "Aggregate functions"},
              {"description": "Expressions"},
              {"description": "Sorting"},
              {"description": "Grouping"},
              {"description": "Sub queries"}
            ]
          },
          {
            "id": 24,
            "title": "Criteria Queries",
            "content": [
              {"description": "Creating Criteria"},
              {"description": "Narrowing the Result"},
              {"description": "Ordering the Result"}
            ]
          }

        // Add more modules for the "Data Science With Python" course as needed
        ]
      },
      {
        name: "UI/UX Dev",
        slug: "ui-ux-dev",
        icon:'fa-brands fa-uikit',
        mode: "Online & Offline & Hybrid",
        duration:"2 Months",
        logo:'4.png',
        description:"Transform your creativity into seamless digital experiences with our UI/UX Design course. Learn the principles of user interface and user experience design, wireframing, prototyping, and usability testing. Master tools like Figma, Adobe XD, and Sketch to design intuitive, engaging, and visually appealing applications. This course empowers you to create designs that not only look great but also provide an exceptional user experience.",
        modules: [
          {
            id: 1,
            title: "Phase-1",
            content: [
              {description: " Basic Photoshop"},
              {description: "HTML"},
              {description: "CSS"},
              {description: "Float based 6-10 layouts"},
              {description: "Google tools - google fonts, developer tool, google drive, google docs"},
              {description: "Team presentations"},
              {description: "Mock interview"},
            ]
          },
          {
            id: 2,
            title: "Phase-2",
            content: [
              {description: "Media query"},
              {description: "HTML5"},
              {description: "CSS3"},
              {description: "Bootstrap-4"},
              {description: "5-10 bootstrap layouts"},
              {description: "Team presentations"},

            ]
          },
          {
            id: 3,
            title: "Phase-3",
            content: [
              {description: "Javascript"},
              {description: "JQuery"},
              {description: "AngularJS"},
              {description: "Webflow no code tool"},
              {description: "Google AMP basic"},
              {description: "Mock interviews"},
              {description: "Mock interview"},
            ]
          },
          {
            id: 4,
            title: "Phase-4",
            content: [
              {description: "Resume preparation"},
              {description: "Interview Preparation"},
              {description: "Mock interviews from industry people"},
            ]
          },
          {
            id: 5,
            title: "Other Tools",
            content: [
              {description: "Version controls tools git, github"},
              {description: "Debugging tools - google developer tool"},
              {description: "Ticketing tool - jira"},
            ]
          },

        ]
      },
      {
        name: "Javascript",
        slug: "javascript",
        icon:'fa-brands fa-js',
        logo:'13.png',
        description:"Bring web pages to life with our JavaScript course. Learn how to create dynamic, interactive, and responsive web applications using core JavaScript concepts, DOM manipulation, and event handling. Gain hands-on experience with modern ES6+ features, asynchronous programming, and working with APIs. This course equips you with the skills to build engaging web experiences and become a confident front-end developer.",

        modules: [
          {
            id: 1,
            title: "JavaScript",
            content: [
              {description: "JavaScript Basic"},
              {description: "Functions & Scope"},
              {description: "Arrays and Objects"},
              {description: "ES6 Features"},
              {description: "Prototypes & Inheritance"},
              {description: "Promises and async/await"},
              {description: "Error handling"},
              {description: "Modules & ES6 import/export"},
              {description: "Introduction to DOM"}
            ]
          },

        // Add more modules for the "Data Science With Python" course as needed
        ]
      },
      {
        name: "React JS",
        slug: "reactjs",
        icon:'fa-brands fa-react',
        mode: "Online & Offline & Hybrid",
        duration:"3 Months",
        logo:'5.png',
        description:"React is a JavaScript library used for building user interfaces (UI) for web applications. It follows a component-based approach, where each UI element is defined as a separate component. React's core concepts include the virtual DOM, JSX (JavaScript XML) syntax, and unidirectional data flow. It's performance-oriented and enables developers to create efficient and scalable web applications. React has a large and vibrant ecosystem with many third-party libraries and tools available to make development easier and more powerful. Overall, React is a powerful, flexible, and popular framework widely used in modern web development.",
        modules: [
          {
            "id": 23,
            "title": "HTML",
            "content": [
              {"description": "HTML Structure: <HTML>, <head>, <body> tags"},
              {"description": "Semantic HTML: <header>, <footer>, <nav>, <article>, <section>, <aside>"},
              {"description": "HTML Attributes: id, class, src, href, alt, title, style, data-* etc."},
              {"description": "Forms: <form>, <input>, <select>, <textarea>, <button> and form attributes"},
              {"description": "HTML5 Features: <video>, <audio>, <canvas>, <svg>, <progress>, <meter>, <details>, <summary> etc."},
              {"description": "Media Elements: <img>, <audio>, <video> etc."},
              {"description": "Hyperlinks and Meta Tags: href, target, rel"},
              {"description": "Tables and Lists: <table>, <tr>, <td>, <the>, <ol>,<ul>, <li>"},
              {"description": "Accessibility: Understanding basic principles of web accessibility and using HTML features to improve accessibility"}
            ]
          },
          {
            "id": 24,
            "title": "CSS",
            "content": [
              {"description": "CSS selectors: type, class, ID, attributes etc."},
              {"description": "Box Model: width, height, padding, margin, and border"},
              {"description": "Flexbox, Grid, Positioning(static, relative, absolute, and fixed)"},
              {"description": "Responsive Design, Transitions, and Animations"},
              {"description": "Fonts and Typography(font family, size, weight, etc.), Colors and Backgrounds"},
              {"description": "Pseudo-classes and Pseudo-elements: classes(:hover, :active, :focus) and elements(::before, ::after)"}
            ]
          },
          {
            "id": 25,
            "title": "Bootstrap (BS)",
            "content": [
              {"description": "Grid System: creating responsive layouts with rows and columns"},
              {"description": "Components: navigation bars, buttons, forms, cards, modals, etc."},
              {"description": "Utilities: styling of elements (e.g., spacing, typography, alignment, etc.)"},
              {"description": "Customization: customize Bootstrap styles by leveraging SASS variables, mixins, and utilities"},
              {"description": "Responsive Design: Responsive design through its grid system and utility classes"},
              {"description": "Integration with React and Theming"}
            ]
          },
          {
            "id": 26,
            "title": "JavaScript",
            "content": [
              {"description": "JavaScript Basic"},
              {"description": "Functions & Scope"},
              {"description": "Arrays and Objects"},
              {"description": "ES6 FeaturesPrototypes & Inheritance"},
              {"description": "Promises and async/await"},
              {"description": "Error handling"},
              {"description": "Modules & ES6 import/export"},
              {"description": "Introduction to DOM"}
            ]
          },
          {
            "id": 27,
            "title": "React JS Fundamentals",
            "content": [
              {"description": "Introduction to React JS"},
              {"description": "Setting up a React Development Environment"},
              {"description": "Event handling in React"},
              {"description": "Conditional rendering"},
              {"description": "Lists & keys"},
              {"description": "React Router for navigation"},
              {"description": "Forms & Form handling"},
              {"description": "JSX Syntax and Features"},
              {"description": "Components and Props"},
              {"description": "State and Lifecycle Methods"}
            ]
          },
          {
            "id": 28,
            "title": "Advanced React Concepts",
            "content": [
              {"description": "React Hooks(useState/ useEffects, useContext, etc)"},
              {"description": "Context API & Global State Management"},
              {"description": "Error Boundaries"},
              {"description": "Higher-Order Components (HOCs)"},
              {"description": "Render Props"},
              {"description": "Composition vs Inheritance"}
            ]
          },
          {
            "id": 29,
            "title": "React Router",
            "content": [
              {"description": "Introduction to React Router"},
              {"description": "Setting up React Router"},
              {"description": "Route Parameters"},
              {"description": "Nested Routes and Nested Navigation"},
              {"description": "Programmatic Navigation"},
              {"description": "Redirects and Authentication"}
            ]
          },
          {
            "id": 30,
            "title": "State Management",
            "content": [
              {"description": "Introduction to Redux"},
              {"description": "Redux Core Concepts (Actions, Reducers, Store)"},
              {"description": "Connecting Redux with React"},
              {"description": "Asynchronous Actions and Thunks"},
              {"description": "Redux Middleware"},
              {"description": "Introduction to Immer and Redux Toolkit"}
            ]
          },
          {
            "id": 31,
            "title": "Styling in React",
            "content": [
              {"description": "CSS Modules"},
              {"description": "Styled Components"},
              {"description": "CSS-in-JS Libraries"},
              {"description": "Theming in React"},
              {"description": "Responsive Design with CSS Media Queries"}
            ]
          },
          {
            "id": 32,
            "title": "Testing React Applications",
            "content": [
              {"description": "Introduction to Testing in React"},
              {"description": "Setting up Jest and Enzyme"},
              {"description": "Writing Unit Tests for Components"},
              {"description": "Snapshot Testing"},
              {"description": "Testing Redux Actions and Reducers"},
              {"description": "Integration Testing with React Testing Library"}
            ]
          },
          {
            "id": 33,
            "title": "Performance Optimization",
            "content": [
              {"description": "Code Splitting"},
              {"description": "Lazy Loading"},
              {"description": "Memoization and Virtualization"},
              {"description": "React.memo and useMemo"},
              {"description": "Profiling React Applications"}
            ]
          },
          {
            "id": 34,
            "title": "Advanced Topics",
            "content": [
              {"description": "Server-Side Rendering (SSR) with React"},
              {"description": "Progressive Web Apps (PWAs)"},
              {"description": "Web Accessibility (a11y) in React Applications"},
              {"description": "Internationalization (i18n) in React"},
              {"description": "GraphQL with React"},
              {"description": "Next.js or Gatsby.js for Static Site Generation"}
            ]
          },
          {
            "id": 35,
            "title": "Deployment and Continuous Integration",
            "content": [
              {"description": "Bundling React Applications with Webpack"},
              {"description": "Deploying React Apps to Various Platforms (Heroku, Netlify, Vercel, etc.)"},
              {"description": "Continuous Integration and Deployment (CI/CD) Pipelines"},
              {"description": "Dockerizing React Applications"},
              {"description": "Introduction to Git"},
              {"description": "Github profile creation and installation"}
            ]
          },
          {
            "id": 36,
            "title": "Real-World Projects and Best Practices",
            "content": [
              {"description": "To-Do List application"},
              {"description": "React APP using API integration"},
              {"description": "Task State and Data Flow"},
              {"description": "Task Filtering and Sorting"},
              {"description": "User Authentication"},
              {"description": "Building Real-World Applications with React"},
              {"description": "Code Reviews and Collaborative Development"},
              {"description": "Debugging Techniques, Performance Monitoring and Optimization Strategies for React Applications"}
            ]
          }


        ]
      },

      {
        name: "AWS",
        slug: "aws",
        icon:'fa-brands fa-aws',
        mode: "Online",
        duration:"2.5 Months",
        logo:'7.png',
        description:"Elevate your cloud skills with our AWS course. Learn how to design, deploy, and manage scalable applications on Amazon Web Services. Gain hands-on experience with core AWS services like EC2, S3, Lambda, and RDS, along with best practices for cloud architecture, security, and cost optimization. This course equips you with the knowledge to become a proficient cloud practitioner and advance your career in cloud computing.",
        modules: [
          {
            "id": 1,
            "title": "AWS Introduction",
            "content": [

            ]
          },
          {
            "id": 2,
            "title": "Basics of AWS and Basic concepts",
            "content": [
              { "description":"Services in AWS" }
            ]
          },
          {
            "id": 3,
            "title": "EC2 – Elastic Compute Cloud",
            "content": [
              {"description": "EC2 instances"},
              {"description": "EBS volumes and Snapshots"},
              {"description": "Snapshot Retention Policies"},
              {"description": "AMIs"},
              {"description": "Security Groups, Keypairs"},
              {"description": "Load Balancer"},
              {"description": "Autoscaling Group"},
              {"description": "Launch Templates and more"}
            ]
          },
          {
            "id": 4,
            "title": "VPC – Virtual Private Cloud",
            "content": [
              {"description": "VPC intro"},
              {"description": "Subnetting"},
              {"description": "Components of VPC such and IGW, NAT, SG, NACL, Route Tables and more"},
              {"description": "VPC Peering"}
            ]
          },
          {
            "id": 5,
            "title": "S3 – Simple Storage Service",
            "content": [
              {"description": "Buckets, Objects, Keys"},
              {"description": "Service endpoint"},
              {"description": "S3 architecture"},
              {"description": "Cross region replication"},
              {"description": "Versioning"},
              {"description": "Storage Classes"},
              {"description": "Static Website hosting"},
              {"description": "Introduction to AWS CLI and S3 CLI commands"}
            ]
          },
          {
            "id": 6,
            "title": "IAM – Identity and Access Management",
            "content": [
              {"description": "Users and groups"},
              {"description": "IAM roles"},
              {"description": "Policies and Types of Policies"}
            ]
          },
          {
            "id": 7,
            "title": "Simple Notification Service",
            "content": [
              {"description": "SNS topics, subscription endpoints and more"}
            ]
          },
          {
            "id": 8,
            "title": "Monitoring of Resources using CloudWatch",
            "content": [
              {"description": "Cloud watch components"},
              {"description": "Cloud Watch Events"},
              {"description": "Cloud Watch alarms"},
              {"description": "Cloud Watch Logs"}
            ]
          },
          {
            "id": 9,
            "title": "AWS Account Monitoring using Cloud Trail",
            "content": [
              {"description": "Relational Database Service"},
              {"description": "Basics of Database"},
              {"description": "Types of RDS DB instances"},
              {"description": "Read replica"},
              {"description": "Multi AZ deployment"},
              {"description": "DB and App connection"}
            ]
          }

        ]
      },
      {
        name: "DevOps",
        slug: "devops",
        icon:'fa-solid fa-infinity',
        description:"Accelerate software delivery with our DevOps course. Learn the practices, tools, and culture behind continuous integration, continuous delivery (CI/CD), and automated deployment. Gain hands-on experience with Git, Jenkins, Docker, Kubernetes, and monitoring tools to streamline development and operations. This course empowers you to build efficient, reliable, and scalable software pipelines, bridging the gap between development and operations.",
        mode: "Online",
        duration:"2 Months",
        logo:'8.png',
        modules: [
          {
            id: 1,
            title: "Introduction to AWS/DEVOPS",
            content: []
          },
          {
            id: 2,
            title: "Basics of SDLC",
            content: []
          },
          {
            id: 3,
            title: "Team Structure in IT and roles and responsibilities of various teams",
            content: []
          },
          {
            id: 4,
            title: "Agile and DevOps",
            content: []
          },
          {
            id: 5,
            title: "DevOps Roles and Responsibilities",
            content: []
          },
          {
            id: 6,
            title: "Basic Linux and Shell Scripting",
            content: []
          },

          {
            "id": 7,
            "title": "Basics of Cloud Computing",
            "content": [
              {"description" : "What is Cloud?" },
              {"description" : "Types of Cloud" }, 
              {"description" : "Types of Cloud Services: – SAAS, PAAS, IAAS" },                 
            ]
          },
          {
            "id": 8,
            "title": "Basics of AWS and Basic concepts",
            "content": [
              { "description":"Services in AWS" }
            ]
          },
          {
            "id": 9,
            "title": "EC2 – Elastic Compute Cloud",
            "content": [
              {"description": "EC2 instances"},
              {"description": "EBS volumes and Snapshots"},
              {"description": "Snapshot Retention Policies"},
              {"description": "AMIs"},
              {"description": "Security Groups, Keypairs"},
              {"description": "Load Balancer"},
              {"description": "Autoscaling Group"},
              {"description": "Launch Templates and more"}
            ]
          },
          {
            "id": 10,
            "title": "VPC – Virtual Private Cloud",
            "content": [
              {"description": "VPC intro"},
              {"description": "Subnetting"},
              {"description": "Components of VPC such and IGW, NAT, SG, NACL, Route Tables and more"},
              {"description": "VPC Peering"}
            ]
          },
          {
            "id": 11,
            "title": "S3 – Simple Storage Service",
            "content": [
              {"description": "Buckets, Objects, Keys"},
              {"description": "Service endpoint"},
              {"description": "S3 architecture"},
              {"description": "Cross region replication"},
              {"description": "Versioning"},
              {"description": "Storage Classes"},
              {"description": "Static Website hosting"},
              {"description": "Introduction to AWS CLI and S3 CLI commands"}
            ]
          },
          {
            "id": 12,
            "title": "IAM – Identity and Access Management",
            "content": [
              {"description": "Users and groups"},
              {"description": "IAM roles"},
              {"description": "Policies and Types of Policies"}
            ]
          },
          {
            "id": 13,
            "title": "Simple Notification Service",
            "content": [
              {"description": "SNS topics, subscription endpoints and more"}
            ]
          },
          {
            "id": 14,
            "title": "Monitoring of Resources using CloudWatch",
            "content": [
              {"description": "Cloud watch components"},
              {"description": "Cloud Watch Events"},
              {"description": "Cloud Watch alarms"},
              {"description": "Cloud Watch Logs"}
            ]
          },
          {
            "id": 15,
            "title": "AWS Account Monitoring using Cloud Trail",
            "content": [
              {"description": "Relational Database Service"},
              {"description": "Basics of Database"},
              {"description": "Types of RDS DB instances"},
              {"description": "Read replica"},
              {"description": "Multi AZ deployment"},
              {"description": "DB and App connection"}
            ]
          },
          {
            "id": 16,
            "title": "GIT",
            "content": [
              {"description": "Basics of Source Code Management"},
              {"description": "Git Architecture"},
              {"description": "Working on git and collaboration"},
              {"description": "GITHUB working"},
              {"description": "Branches and tags"},
              {"description": "Pull requests and more commands"}
            ]
          },
          {
            "id": 17,
            "title": "MAVEN",
            "content": [
              {"description": "Local repository"},
              {"description": "Remote repository"},
              {"description": "Maven commands"},
              {"description": "Pom.xml and more"}
            ]
          },
          {
            "id": 18,
            "title": "Jenkins",
            "content": [
              {"description": "CICD intro"},
              {"description": "Jenkins Architechture"},
              {"description": "Jenkins installation and components"},
              {"description": "Freestyle jobs"},
              {"description": "Pipeline Scripts with Jenkins File"},
              {"description": "Multipipeline Jenkins job"},
              {"description": "Tool configuration"},
              {"description": "Credentials, user access"},
              {"description": "Plugins and more"},
              {"description": "Slave configuration"}
            ]
          },
          {
            "id": 19,
            "title": "Docker",
            "content": [
              {"description": "Introduction and architecture"},
              {"description": "Installation and components"},
              {"description": "Docker registry, images, containers, volumes and more"},
              {"description": "Dockerfiles"},
              {"description": "Docker-compose"}
            ]
          },
          {
            "id": 20,
            "title": "Ansible",
            "content": [
              {"description": "Intro and Architecture"},
              {"description": "Adhoc commands"},
              {"description": "Ansible modules"},
              {"description": "Ansible playbooks and inventory"},
              {"description": "Ansible vault"}
            ]
          },
          {
            "id": 21,
            "title": "Terraform",
            "content": [
              {"description": "Intro and architecture"},
              {"description": "Terraform providers"},
              {"description": "HCL and basics of HCL language"},
              {"description": "Terraform State file"},
              {"description": "Terraform variables"},
              {"description": "Terraform lifecycle and more concepts"}
            ]
          },
          {
            "id": 22,
            "title": "JIRA basics for DevOps",
            "content": [
              {"description": "Introduction to JIRA basics for DevOps"}
            ]
          }
        ]
      },

      {
        name: "Robotics Process Automation Development (RPA)",
        slug: "robotics-process-automation-development",
        icon:'fa-solid fa-robot',
        mode: "Online & Offline & Hybrid",
        duration:"3 Months",
        logo:'9.png',
        description:'Robotics Process Automation is revolutionizing industries by automating repetitive tasks, streamlining processes, and improving efficiency. In this course section, you’ll explore the fundamentals of RPA development, learn how to create bots that mimic human actions, and discover how RPA can transform businesses across various sectors.',
        modules: [
          {
            "id": 1,
            "title": "Blue Prism",
            "content": [
              {"description": "The architecture pattern of RPA"},
              {"description": "Developing the RPA process"},
              {"description": "The various tools used in RPA"},
              {"description": "The different types of bots"},
              {"description": "Selection criteria"},
              {"description": "The user interface of Blue Prism"},
              {"description": "Different types of bots"},
              {"description": "Lifecycle of RPA"},
              {"description": "Understanding of All Drag and Drop Stages"},
              {"description": "Understanding of All Functions"},
              {"description": "Understanding of Default VBO"},
              {"description": "Understanding of Internal Business Object"},
              {"description": "Understanding of Spying mode"},
              {"description": "Understanding of the type of application"},
              {"description": "Understanding of Windows-based applications and practical knowledge of how to automate them."},
              {"description": "Understanding of Web Base application and practical on how to automate it."},
              {"description": "Understanding of schedular"},
              {"description": "Understanding of Control Room"},
              {"description": "Understanding of Queue Management"},
              {"description": "Understanding of Multi-Bot Architecture"},
              {"description": "Understanding of PDF automation and Practical on how to automate it."},
              {"description": "Understanding of Excel Automation."},
              {"description": "Understanding of Process Studio"},
              {"description": "Understanding of Object Studio."},
              {"description": "Working with variables"},
              {"description": "Details Learning on Application Modular"}
            ]
          },
          {
            "id": 2,
            "title": "UI-Path",
            "content": [
              {"description": "RPA, SDLC Life cycle"},
              {"description": "Solution Design Document, Process Design Document, Data Flow Diagram document understanding"},
              {"description": "UiPath installation"},
              {"description": "UiPath components (Studio, orchestrator, Robot)"},
              {"description": "Variables and Arguments, data types (integer, double, string, data table….)"},
              {"description": "Operators, conditions, and loops (if… else, for each, while, do. While)"},
              {"description": "Collections (Array, List, Dictionary)"},
              {"description": "Data scraping, screen scraping"},
              {"description": "Selectors, UiPath explorer,"},
              {"description": "Functions, Methods (regular expression searching patterns)"},
              {"description": "Sequences, flow chart, and state machine"},
              {"description": "UiPath Activities, manage packages, standard practices"},
              {"description": "Types of recording (web, desktop, web, Citrix)"},
              {"description": "Windows, Web Automation"},
              {"description": "Excel Automation"},
              {"description": "PDF Automation"},
              {"description": "Searching patterns (wild card, regular expression operations)"},
              {"description": "Email automation"},
              {"description": "API (Application Programming Interface) Automation"},
              {"description": "Asset and Queues"},
              {"description": "Database activities (DDL, DML, Joins of Tables)"},
              {"description": "Exception Handling (Technical exception, business Exception, Throw, Rethrow, Try…Catch…finally, Global Exception Handler)"},
              {"description": "Robotic Enterprise Framework"},
              {"description": "Orchestrator (Machine, Environment, Robot creation, monitoring and scheduling BOTs)"},
              {"description": "Production support module ( End to End Bot Deployment, monitoring and troubleshooting )"}
            ]
          }

        ]
      }, 



      {
        name: "Software Testing",
        slug: "software-testing",
        icon:'fa-solid fa-bug',
        mode: "Online & Offline & Hybrid",
        duration:"3 Months",
        logo:'12.png',
        description:'A software testing course is an educational program designed to teach individuals the principles, techniques, and methodologies involved in testing software applications. These courses cover a wide range of topics related to software quality assurance, including manual testing, automated testing, performance testing, security testing, and more. Software testing courses typically include theoretical instruction combined with hands-on practical exercises, case studies, and real-world projects. They may be offered in various formats, including in-person classes, online courses, workshops, and certification programs.',
        modules: [
          {
            "id": 1,
            "title": "Core Java - Section-1 (Basic Java)",
            "content": [
              {"description": "Introduction of java"},
              {"description": "Java & eclipse installation"},
              {"description": "Variable & data types"},
              {"description": "Keywords & Identifiers"},
              {"description": "Methods"},
              {"description": "Types of variables"},
              {"description": "Constructor"},
              {"description": "Control statements"},
              {"description": "Loops"},
              {"description": "Use of static non-static methods"}
            ]
          },
          {
            "id": 2,
            "title": "Core Java -Section-2 (OOPs)",
            "content": [
              {"description": "Inheritance"},
              {"description": "This & super keyword"},
              {"description": "Access specifiers"},
              {"description": "Polymorphism"},
              {"description": "Abstract class & concrete class"},
              {"description": "Interface & Implementation class"},
              {"description": "Generalization"},
              {"description": "Casting"},
              {"description": "Encapsulation"},
              {"description": "Abstraction"}
            ]
          },
          {
            "id": 3,
            "title": "Core Java- Section-3",
            "content": [
              {"description": "String Class"},
              {"description": "Array"},
              {"description": "Exception handling"},
              {"description": "Collection"},
              {"description": "Pattern programs"},
              {"description": "Logical programs"}
            ]
          },
          {
            "id": 4,
            "title": "Selenium - Section-1",
            "content": [
              {"description": "Advantages & Disadvantages of Selenium"},
              {"description": "Selenium flavors"},
              {"description": "Selenium Setup"},
              {"description": "Selenium Architecture"},
              {"description": "WebDriver & its methods"},
              {"description": "Basic HTML coding"},
              {"description": "Types of Locators"},
              {"description": "WebElement & its methods"}
            ]
          },
          {
            "id": 5,
            "title": "Selenium - Section-2",
            "content": [
              {"description": "Handling of Listbox"},
              {"description": "Capture Screenshots using Selenium"},
              {"description": "Parameterization using Excel sheet"},
              {"description": "Handling of Iframe"},
              {"description": "Handling of Popups"},
              {"description": "Handling of multiple elements"},
              {"description": "Handling of Autosuggestions"},
              {"description": "Handling of Dynamic Elements"},
              {"description": "Mouse & Keyboard related actions using the Action class"},
              {"description": "Handling of Customized Listbox"},
              {"description": "Different types of Exception in selenium"},
              {"description": "Handling of WebTable"},
              {"description": "Perform Scroll up/down"},
              {"description": "Synchronization (Different types of waits in selenium)"},
              {"description": "Handling of Notification"}
            ]
          },
          {
            "id": 6,
            "title": "Selenium - Section-3",
            "content": [
              {"description": "What is Selenium Framework? Types of Framework?"},
              {"description": "Example of With & Without DDF Framework"},
              {"description": "POM(Page object module) with Pagefactory"},
              {"description": "POM with DDF"},
              {"description": "Notification"},
              {"description": "TestNG Framework"},
              {"description": "Emailable report"},
              {"description": "Annotations"},
              {"description": "Keywords"},
              {"description": "Test-Suite"},
              {"description": "Assertion/Verification"},
              {"description": "Disable TC Execution From the Suite & Test class"},
              {"description": "Failed.xml file"},
              {"description": "Grouping of Test cases"},
              {"description": "Parallel execution"},
              {"description": "Multi-browser testing"},
              {"description": "Multi-browser testing with parallel execution"},
              {"description": "Difference between TestNG & Junit"},
              {"description": "Advantages of TestNG"},
              {"description": "Integration of framework using POM, DDF & TestNG"},
              {"description": "Maven project"},
              {"description": "Framework explanation"},
              {"description": "Oops concepts in Selenium Framework"},
              {"description": "Design of Automation testing Scenarios using the framework"},
              {"description": "Automation life cycle"},
              {"description": "Interview Questions"},
              {"description": "Github"}
            ]
          },
          {
            "id": 7,
            "title": "Manual Part 1",
            "content": [
              {"description": "Different Processes, Different Testing types"},
            ]
          },
          {
            "id": 8,
            "title": "Manual Part 2",
            "content": [

            ]
          },
          {
            "id": 9,
            "title": "Real tester work",
            "content": [
              {"description": "TCD and Review"},
              {"description": "TCE"},
              {"description": "Defect report"},
              {"description": "Different report preparation, etc"},
              {"description": "Real-time Project/Bug-tracking tools"},
              {"description": "Real-Time project and Unix"}
            ]
          },
          {
            "id": 10,
            "title": "Database Testing",
            "content": [{
              "description":"API testing/ Web series Testing + Automation with BDD framework"
            }]
          },
        ]
      },
    ];

    export default coursesData;